"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: txactivity/activity-context.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Ftxactivity%2Factivity-context.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.RewardOrigin = exports.FeePayment = exports.TransferRoundUpOrigin = exports.Transfer = exports.Referral = exports.OfferReward = exports.P2PReversal = exports.P2P = exports.InstallmentLoanBalanceTransfer = exports.InstallmentLoanPaymentInstallmentPayment = exports.InstallmentLoanPayment = exports.InstallmentLoanFunding = exports.FundingReversal = exports.FundingFeeReversal = exports.FundingFee = exports.FundingDisputeReversal = exports.FundingDispute = exports.Funding = exports.CheckDepositReturn = exports.CheckDeposit = exports.CashDeposit = exports.Refund = exports.AtmPurchase = exports.DisputeState = exports.PurchaseAccount = exports.PurchaseBreakdown = exports.Authorization = exports.PurchaseRoundUpCryptoContext = exports.PurchaseRoundUpStockContext = exports.PurchasePurchaseMove = exports.PurchaseRoundUp = exports.PurchaseInstallmentLoan = exports.Purchase = exports.DisputeReversal = exports.Dispute = exports.Debit = exports.Credit = exports.AtmWithdrawal = exports.AchOutDebitReversal = exports.AchOutDebit = exports.AchOutCreditReversal = exports.AchOutCredit = exports.AchInDebitReversal = exports.AchInDebit = exports.AchInCreditReversal = exports.AchInCredit = exports.ActivityContext = exports.PurchaseEventType = exports.PurchaseAccountType = exports.ActivityContextType = void 0;
exports.purchaseEventTypeToJSON = exports.purchaseEventTypeFromJSON = exports.purchaseAccountTypeToJSON = exports.purchaseAccountTypeFromJSON = exports.activityContextTypeToJSON = exports.activityContextTypeFromJSON = exports.GiftCardPointsRedeemReversal = exports.GiftCardPointsRedeem = exports.SavingsMatch = exports.CashAdvance = exports.SubscriptionRefund = exports.Subscription = exports.PointsRedeem = exports.PointsReward = exports.CreditBalancePayment = exports.CreditBillingInterest = exports.CreditBillingFee = exports.SavingsInterest = exports.Instrument = exports.Merchant = exports.CardPayoutDetails = exports.FundingDetails = exports.CardDetails = exports.Bank = exports.AchInParties = exports.StockCustomerAccountTransfer = exports.StockInterestAdjustment = exports.StockGraduationTransfer = exports.StockCorporateActionTransfer = exports.StockTradeTransferOrderAdjustment = exports.StockTradeTransferSale = exports.StockTradeTransferPurchase = exports.StockTradeTransfer = exports.StockCorporateAction = exports.StockFeesSaleFees = exports.StockFeesSale = exports.StockFees = exports.StockTradeSale = exports.StockTradePurchase = exports.StockTrade = exports.CryptoTradeTransfer = exports.CryptoTrade = exports.CardPayoutFeeReversal = exports.CardPayoutFee = exports.CardPayoutReversal = exports.CardPayout = void 0;
const ach_account_1 = require("../common/ach-account");
const amount_1 = require("../common/amount");
const atm_1 = require("../common/atm");
const card_details_1 = require("../common/card-details");
const date_1 = require("../common/date");
const digital_currency_1 = require("../common/digital-currency");
const dispute_reason_1 = require("../common/dispute-reason");
const external_card_1 = require("../common/external-card");
const fee_type_1 = require("../common/fee-type");
const financial_instrument_1 = require("../common/financial-instrument");
const merchant_1 = require("../common/merchant");
const offer_1 = require("../common/offer");
const qualifying_event_1 = require("../common/qualifying-event");
const savings_goal_1 = require("../common/savings-goal");
const stock_corporate_action_1 = require("../common/stock-corporate-action");
const stock_order_1 = require("../common/stock-order");
const transfer_request_status_1 = require("../common/transfer-request-status");
const wallet_provider_1 = require("../common/wallet-provider");
const check_return_reason_1 = require("../ledger/check-return-reason");
const fee_context_1 = require("../ledger/fee-context");
const payment_ach_in_1 = require("../ledger/payment-ach-in");
const payment_ach_out_1 = require("../ledger/payment-ach-out");
const payment_card_1 = require("../ledger/payment-card");
const payment_cash_deposit_1 = require("../ledger/payment-cash-deposit");
const payment_gift_card_order_1 = require("../ledger/payment-gift-card-order");
const payment_installment_loan_1 = require("../ledger/payment-installment-loan");
const payment_p2p_1 = require("../ledger/payment-p2p");
const payment_referral_1 = require("../ledger/payment-referral");
const payment_subscription_1 = require("../ledger/payment-subscription");
const payment_transfer_1 = require("../ledger/payment-transfer");
const transaction_error_code_1 = require("../ledger/transaction-error-code");
const activity_common_1 = require("./activity-common");
const protobufPackage = 'com.step.txactivity.proto';
/**
 * Types in enum form to filter on
 */
var ActivityContextType;
(function (ActivityContextType) {
    ActivityContextType["INVALID_ACTIVITY_CONTEXT"] = "INVALID_ACTIVITY_CONTEXT";
    ActivityContextType["CREDIT_BALANCE_PAYMENT"] = "CREDIT_BALANCE_PAYMENT";
    ActivityContextType["INSTALLMENT_LOAN_PAYMENT"] = "INSTALLMENT_LOAN_PAYMENT";
    ActivityContextType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(ActivityContextType || (exports.ActivityContextType = ActivityContextType = {}));
var PurchaseAccountType;
(function (PurchaseAccountType) {
    PurchaseAccountType["INVALID_PURCHASE_ACCOUNT_TYPE"] = "INVALID_PURCHASE_ACCOUNT_TYPE";
    PurchaseAccountType["SECURED_PURCHASE_ACCOUNT"] = "SECURED_PURCHASE_ACCOUNT";
    PurchaseAccountType["UNSECURED_PURCHASE_ACCOUNT"] = "UNSECURED_PURCHASE_ACCOUNT";
    PurchaseAccountType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(PurchaseAccountType || (exports.PurchaseAccountType = PurchaseAccountType = {}));
var PurchaseEventType;
(function (PurchaseEventType) {
    PurchaseEventType["INVALID_PURCHASE_EVENT_TYPE"] = "INVALID_PURCHASE_EVENT_TYPE";
    PurchaseEventType["PENDING_AUTHORIZATION_EVENT"] = "PENDING_AUTHORIZATION_EVENT";
    PurchaseEventType["DECLINED_AUTHORIZATION_EVENT"] = "DECLINED_AUTHORIZATION_EVENT";
    PurchaseEventType["REVERSED_AUTHORIZATION_EVENT"] = "REVERSED_AUTHORIZATION_EVENT";
    PurchaseEventType["CAPTURE_EVENT"] = "CAPTURE_EVENT";
    PurchaseEventType["REFUND_EVENT"] = "REFUND_EVENT";
    PurchaseEventType["DISPUTE_CREDIT_EVENT"] = "DISPUTE_CREDIT_EVENT";
    PurchaseEventType["DISPUTE_CREDIT_REVERSAL_EVENT"] = "DISPUTE_CREDIT_REVERSAL_EVENT";
    PurchaseEventType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(PurchaseEventType || (exports.PurchaseEventType = PurchaseEventType = {}));
function createBaseActivityContext() {
    return {
        achInCredit: undefined,
        achInCreditReversal: undefined,
        achInDebit: undefined,
        achInDebitReversal: undefined,
        achOutCredit: undefined,
        achOutCreditReversal: undefined,
        achOutDebit: undefined,
        achOutDebitReversal: undefined,
        atmWithdrawal: undefined,
        cardPayout: undefined,
        cardPayoutFee: undefined,
        cardPayoutFeeReversal: undefined,
        cardPayoutReversal: undefined,
        cashDeposit: undefined,
        cashAdvance: undefined,
        checkDeposit: undefined,
        checkDepositReturn: undefined,
        credit: undefined,
        creditBalancePayment: undefined,
        creditBillingFee: undefined,
        creditBillingInterest: undefined,
        cryptoTrade: undefined,
        cryptoTradeTransfer: undefined,
        debit: undefined,
        dispute: undefined,
        disputeReversal: undefined,
        fee: undefined,
        funding: undefined,
        fundingDispute: undefined,
        fundingDisputeReversal: undefined,
        fundingFee: undefined,
        fundingFeeReversal: undefined,
        fundingReversal: undefined,
        giftCardPointsRedeem: undefined,
        giftCardPointsRedeemReversal: undefined,
        installmentLoanBalanceTransfer: undefined,
        installmentLoanFunding: undefined,
        installmentLoanPayment: undefined,
        offerReward: undefined,
        p2p: undefined,
        p2pReversal: undefined,
        pointsRedeem: undefined,
        pointsReward: undefined,
        purchase: undefined,
        referral: undefined,
        refund: undefined,
        savingsInterest: undefined,
        savingsMatch: undefined,
        stockCorporateAction: undefined,
        stockCorporateActionTransfer: undefined,
        stockFees: undefined,
        stockInterestAdjustment: undefined,
        stockTrade: undefined,
        stockTradeTransfer: undefined,
        stockGraduationTransfer: undefined,
        stockCustomerAccountTransfer: undefined,
        subscription: undefined,
        subscriptionRefund: undefined,
        transfer: undefined,
    };
}
exports.ActivityContext = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.achInCredit)) {
            message.achInCredit = exports.AchInCredit.fromJSON(object.achInCredit);
        }
        if (isSet(object.achInCreditReversal)) {
            message.achInCreditReversal = exports.AchInCreditReversal.fromJSON(object.achInCreditReversal);
        }
        if (isSet(object.achInDebit)) {
            message.achInDebit = exports.AchInDebit.fromJSON(object.achInDebit);
        }
        if (isSet(object.achInDebitReversal)) {
            message.achInDebitReversal = exports.AchInDebitReversal.fromJSON(object.achInDebitReversal);
        }
        if (isSet(object.achOutCredit)) {
            message.achOutCredit = exports.AchOutCredit.fromJSON(object.achOutCredit);
        }
        if (isSet(object.achOutCreditReversal)) {
            message.achOutCreditReversal = exports.AchOutCreditReversal.fromJSON(object.achOutCreditReversal);
        }
        if (isSet(object.achOutDebit)) {
            message.achOutDebit = exports.AchOutDebit.fromJSON(object.achOutDebit);
        }
        if (isSet(object.achOutDebitReversal)) {
            message.achOutDebitReversal = exports.AchOutDebitReversal.fromJSON(object.achOutDebitReversal);
        }
        if (isSet(object.atmWithdrawal)) {
            message.atmWithdrawal = exports.AtmWithdrawal.fromJSON(object.atmWithdrawal);
        }
        if (isSet(object.cardPayout)) {
            message.cardPayout = exports.CardPayout.fromJSON(object.cardPayout);
        }
        if (isSet(object.cardPayoutFee)) {
            message.cardPayoutFee = exports.CardPayoutFee.fromJSON(object.cardPayoutFee);
        }
        if (isSet(object.cardPayoutFeeReversal)) {
            message.cardPayoutFeeReversal = exports.CardPayoutFeeReversal.fromJSON(object.cardPayoutFeeReversal);
        }
        if (isSet(object.cardPayoutReversal)) {
            message.cardPayoutReversal = exports.CardPayoutReversal.fromJSON(object.cardPayoutReversal);
        }
        if (isSet(object.cashDeposit)) {
            message.cashDeposit = exports.CashDeposit.fromJSON(object.cashDeposit);
        }
        if (isSet(object.cashAdvance)) {
            message.cashAdvance = exports.CashAdvance.fromJSON(object.cashAdvance);
        }
        if (isSet(object.checkDeposit)) {
            message.checkDeposit = exports.CheckDeposit.fromJSON(object.checkDeposit);
        }
        if (isSet(object.checkDepositReturn)) {
            message.checkDepositReturn = exports.CheckDepositReturn.fromJSON(object.checkDepositReturn);
        }
        if (isSet(object.credit)) {
            message.credit = exports.Credit.fromJSON(object.credit);
        }
        if (isSet(object.creditBalancePayment)) {
            message.creditBalancePayment = exports.CreditBalancePayment.fromJSON(object.creditBalancePayment);
        }
        if (isSet(object.creditBillingFee)) {
            message.creditBillingFee = exports.CreditBillingFee.fromJSON(object.creditBillingFee);
        }
        if (isSet(object.creditBillingInterest)) {
            message.creditBillingInterest = exports.CreditBillingInterest.fromJSON(object.creditBillingInterest);
        }
        if (isSet(object.cryptoTrade)) {
            message.cryptoTrade = exports.CryptoTrade.fromJSON(object.cryptoTrade);
        }
        if (isSet(object.cryptoTradeTransfer)) {
            message.cryptoTradeTransfer = exports.CryptoTradeTransfer.fromJSON(object.cryptoTradeTransfer);
        }
        if (isSet(object.debit)) {
            message.debit = exports.Debit.fromJSON(object.debit);
        }
        if (isSet(object.dispute)) {
            message.dispute = exports.Dispute.fromJSON(object.dispute);
        }
        if (isSet(object.disputeReversal)) {
            message.disputeReversal = exports.DisputeReversal.fromJSON(object.disputeReversal);
        }
        if (isSet(object.fee)) {
            message.fee = exports.FeePayment.fromJSON(object.fee);
        }
        if (isSet(object.funding)) {
            message.funding = exports.Funding.fromJSON(object.funding);
        }
        if (isSet(object.fundingDispute)) {
            message.fundingDispute = exports.FundingDispute.fromJSON(object.fundingDispute);
        }
        if (isSet(object.fundingDisputeReversal)) {
            message.fundingDisputeReversal = exports.FundingDisputeReversal.fromJSON(object.fundingDisputeReversal);
        }
        if (isSet(object.fundingFee)) {
            message.fundingFee = exports.FundingFee.fromJSON(object.fundingFee);
        }
        if (isSet(object.fundingFeeReversal)) {
            message.fundingFeeReversal = exports.FundingFeeReversal.fromJSON(object.fundingFeeReversal);
        }
        if (isSet(object.fundingReversal)) {
            message.fundingReversal = exports.FundingReversal.fromJSON(object.fundingReversal);
        }
        if (isSet(object.giftCardPointsRedeem)) {
            message.giftCardPointsRedeem = exports.GiftCardPointsRedeem.fromJSON(object.giftCardPointsRedeem);
        }
        if (isSet(object.giftCardPointsRedeemReversal)) {
            message.giftCardPointsRedeemReversal = exports.GiftCardPointsRedeemReversal.fromJSON(object.giftCardPointsRedeemReversal);
        }
        if (isSet(object.installmentLoanBalanceTransfer)) {
            message.installmentLoanBalanceTransfer = exports.InstallmentLoanBalanceTransfer.fromJSON(object.installmentLoanBalanceTransfer);
        }
        if (isSet(object.installmentLoanFunding)) {
            message.installmentLoanFunding = exports.InstallmentLoanFunding.fromJSON(object.installmentLoanFunding);
        }
        if (isSet(object.installmentLoanPayment)) {
            message.installmentLoanPayment = exports.InstallmentLoanPayment.fromJSON(object.installmentLoanPayment);
        }
        if (isSet(object.offerReward)) {
            message.offerReward = exports.OfferReward.fromJSON(object.offerReward);
        }
        if (isSet(object.p2p)) {
            message.p2p = exports.P2P.fromJSON(object.p2p);
        }
        if (isSet(object.p2pReversal)) {
            message.p2pReversal = exports.P2PReversal.fromJSON(object.p2pReversal);
        }
        if (isSet(object.pointsRedeem)) {
            message.pointsRedeem = exports.PointsRedeem.fromJSON(object.pointsRedeem);
        }
        if (isSet(object.pointsReward)) {
            message.pointsReward = exports.PointsReward.fromJSON(object.pointsReward);
        }
        if (isSet(object.purchase)) {
            message.purchase = exports.Purchase.fromJSON(object.purchase);
        }
        if (isSet(object.referral)) {
            message.referral = exports.Referral.fromJSON(object.referral);
        }
        if (isSet(object.refund)) {
            message.refund = exports.Refund.fromJSON(object.refund);
        }
        if (isSet(object.savingsInterest)) {
            message.savingsInterest = exports.SavingsInterest.fromJSON(object.savingsInterest);
        }
        if (isSet(object.savingsMatch)) {
            message.savingsMatch = exports.SavingsMatch.fromJSON(object.savingsMatch);
        }
        if (isSet(object.stockCorporateAction)) {
            message.stockCorporateAction = exports.StockCorporateAction.fromJSON(object.stockCorporateAction);
        }
        if (isSet(object.stockCorporateActionTransfer)) {
            message.stockCorporateActionTransfer = exports.StockCorporateActionTransfer.fromJSON(object.stockCorporateActionTransfer);
        }
        if (isSet(object.stockFees)) {
            message.stockFees = exports.StockFees.fromJSON(object.stockFees);
        }
        if (isSet(object.stockInterestAdjustment)) {
            message.stockInterestAdjustment = exports.StockInterestAdjustment.fromJSON(object.stockInterestAdjustment);
        }
        if (isSet(object.stockTrade)) {
            message.stockTrade = exports.StockTrade.fromJSON(object.stockTrade);
        }
        if (isSet(object.stockTradeTransfer)) {
            message.stockTradeTransfer = exports.StockTradeTransfer.fromJSON(object.stockTradeTransfer);
        }
        if (isSet(object.stockGraduationTransfer)) {
            message.stockGraduationTransfer = exports.StockGraduationTransfer.fromJSON(object.stockGraduationTransfer);
        }
        if (isSet(object.stockCustomerAccountTransfer)) {
            message.stockCustomerAccountTransfer = exports.StockCustomerAccountTransfer.fromJSON(object.stockCustomerAccountTransfer);
        }
        if (isSet(object.subscription)) {
            message.subscription = exports.Subscription.fromJSON(object.subscription);
        }
        if (isSet(object.subscriptionRefund)) {
            message.subscriptionRefund = exports.SubscriptionRefund.fromJSON(object.subscriptionRefund);
        }
        if (isSet(object.transfer)) {
            message.transfer = exports.Transfer.fromJSON(object.transfer);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.achInCredit !== undefined) {
            obj.achInCredit = exports.AchInCredit.toJSON(message.achInCredit);
        }
        if (message.achInCreditReversal !== undefined) {
            obj.achInCreditReversal = exports.AchInCreditReversal.toJSON(message.achInCreditReversal);
        }
        if (message.achInDebit !== undefined) {
            obj.achInDebit = exports.AchInDebit.toJSON(message.achInDebit);
        }
        if (message.achInDebitReversal !== undefined) {
            obj.achInDebitReversal = exports.AchInDebitReversal.toJSON(message.achInDebitReversal);
        }
        if (message.achOutCredit !== undefined) {
            obj.achOutCredit = exports.AchOutCredit.toJSON(message.achOutCredit);
        }
        if (message.achOutCreditReversal !== undefined) {
            obj.achOutCreditReversal = exports.AchOutCreditReversal.toJSON(message.achOutCreditReversal);
        }
        if (message.achOutDebit !== undefined) {
            obj.achOutDebit = exports.AchOutDebit.toJSON(message.achOutDebit);
        }
        if (message.achOutDebitReversal !== undefined) {
            obj.achOutDebitReversal = exports.AchOutDebitReversal.toJSON(message.achOutDebitReversal);
        }
        if (message.atmWithdrawal !== undefined) {
            obj.atmWithdrawal = exports.AtmWithdrawal.toJSON(message.atmWithdrawal);
        }
        if (message.cardPayout !== undefined) {
            obj.cardPayout = exports.CardPayout.toJSON(message.cardPayout);
        }
        if (message.cardPayoutFee !== undefined) {
            obj.cardPayoutFee = exports.CardPayoutFee.toJSON(message.cardPayoutFee);
        }
        if (message.cardPayoutFeeReversal !== undefined) {
            obj.cardPayoutFeeReversal = exports.CardPayoutFeeReversal.toJSON(message.cardPayoutFeeReversal);
        }
        if (message.cardPayoutReversal !== undefined) {
            obj.cardPayoutReversal = exports.CardPayoutReversal.toJSON(message.cardPayoutReversal);
        }
        if (message.cashDeposit !== undefined) {
            obj.cashDeposit = exports.CashDeposit.toJSON(message.cashDeposit);
        }
        if (message.cashAdvance !== undefined) {
            obj.cashAdvance = exports.CashAdvance.toJSON(message.cashAdvance);
        }
        if (message.checkDeposit !== undefined) {
            obj.checkDeposit = exports.CheckDeposit.toJSON(message.checkDeposit);
        }
        if (message.checkDepositReturn !== undefined) {
            obj.checkDepositReturn = exports.CheckDepositReturn.toJSON(message.checkDepositReturn);
        }
        if (message.credit !== undefined) {
            obj.credit = exports.Credit.toJSON(message.credit);
        }
        if (message.creditBalancePayment !== undefined) {
            obj.creditBalancePayment = exports.CreditBalancePayment.toJSON(message.creditBalancePayment);
        }
        if (message.creditBillingFee !== undefined) {
            obj.creditBillingFee = exports.CreditBillingFee.toJSON(message.creditBillingFee);
        }
        if (message.creditBillingInterest !== undefined) {
            obj.creditBillingInterest = exports.CreditBillingInterest.toJSON(message.creditBillingInterest);
        }
        if (message.cryptoTrade !== undefined) {
            obj.cryptoTrade = exports.CryptoTrade.toJSON(message.cryptoTrade);
        }
        if (message.cryptoTradeTransfer !== undefined) {
            obj.cryptoTradeTransfer = exports.CryptoTradeTransfer.toJSON(message.cryptoTradeTransfer);
        }
        if (message.debit !== undefined) {
            obj.debit = exports.Debit.toJSON(message.debit);
        }
        if (message.dispute !== undefined) {
            obj.dispute = exports.Dispute.toJSON(message.dispute);
        }
        if (message.disputeReversal !== undefined) {
            obj.disputeReversal = exports.DisputeReversal.toJSON(message.disputeReversal);
        }
        if (message.fee !== undefined) {
            obj.fee = exports.FeePayment.toJSON(message.fee);
        }
        if (message.funding !== undefined) {
            obj.funding = exports.Funding.toJSON(message.funding);
        }
        if (message.fundingDispute !== undefined) {
            obj.fundingDispute = exports.FundingDispute.toJSON(message.fundingDispute);
        }
        if (message.fundingDisputeReversal !== undefined) {
            obj.fundingDisputeReversal = exports.FundingDisputeReversal.toJSON(message.fundingDisputeReversal);
        }
        if (message.fundingFee !== undefined) {
            obj.fundingFee = exports.FundingFee.toJSON(message.fundingFee);
        }
        if (message.fundingFeeReversal !== undefined) {
            obj.fundingFeeReversal = exports.FundingFeeReversal.toJSON(message.fundingFeeReversal);
        }
        if (message.fundingReversal !== undefined) {
            obj.fundingReversal = exports.FundingReversal.toJSON(message.fundingReversal);
        }
        if (message.giftCardPointsRedeem !== undefined) {
            obj.giftCardPointsRedeem = exports.GiftCardPointsRedeem.toJSON(message.giftCardPointsRedeem);
        }
        if (message.giftCardPointsRedeemReversal !== undefined) {
            obj.giftCardPointsRedeemReversal = exports.GiftCardPointsRedeemReversal.toJSON(message.giftCardPointsRedeemReversal);
        }
        if (message.installmentLoanBalanceTransfer !== undefined) {
            obj.installmentLoanBalanceTransfer = exports.InstallmentLoanBalanceTransfer.toJSON(message.installmentLoanBalanceTransfer);
        }
        if (message.installmentLoanFunding !== undefined) {
            obj.installmentLoanFunding = exports.InstallmentLoanFunding.toJSON(message.installmentLoanFunding);
        }
        if (message.installmentLoanPayment !== undefined) {
            obj.installmentLoanPayment = exports.InstallmentLoanPayment.toJSON(message.installmentLoanPayment);
        }
        if (message.offerReward !== undefined) {
            obj.offerReward = exports.OfferReward.toJSON(message.offerReward);
        }
        if (message.p2p !== undefined) {
            obj.p2p = exports.P2P.toJSON(message.p2p);
        }
        if (message.p2pReversal !== undefined) {
            obj.p2pReversal = exports.P2PReversal.toJSON(message.p2pReversal);
        }
        if (message.pointsRedeem !== undefined) {
            obj.pointsRedeem = exports.PointsRedeem.toJSON(message.pointsRedeem);
        }
        if (message.pointsReward !== undefined) {
            obj.pointsReward = exports.PointsReward.toJSON(message.pointsReward);
        }
        if (message.purchase !== undefined) {
            obj.purchase = exports.Purchase.toJSON(message.purchase);
        }
        if (message.referral !== undefined) {
            obj.referral = exports.Referral.toJSON(message.referral);
        }
        if (message.refund !== undefined) {
            obj.refund = exports.Refund.toJSON(message.refund);
        }
        if (message.savingsInterest !== undefined) {
            obj.savingsInterest = exports.SavingsInterest.toJSON(message.savingsInterest);
        }
        if (message.savingsMatch !== undefined) {
            obj.savingsMatch = exports.SavingsMatch.toJSON(message.savingsMatch);
        }
        if (message.stockCorporateAction !== undefined) {
            obj.stockCorporateAction = exports.StockCorporateAction.toJSON(message.stockCorporateAction);
        }
        if (message.stockCorporateActionTransfer !== undefined) {
            obj.stockCorporateActionTransfer = exports.StockCorporateActionTransfer.toJSON(message.stockCorporateActionTransfer);
        }
        if (message.stockFees !== undefined) {
            obj.stockFees = exports.StockFees.toJSON(message.stockFees);
        }
        if (message.stockInterestAdjustment !== undefined) {
            obj.stockInterestAdjustment = exports.StockInterestAdjustment.toJSON(message.stockInterestAdjustment);
        }
        if (message.stockTrade !== undefined) {
            obj.stockTrade = exports.StockTrade.toJSON(message.stockTrade);
        }
        if (message.stockTradeTransfer !== undefined) {
            obj.stockTradeTransfer = exports.StockTradeTransfer.toJSON(message.stockTradeTransfer);
        }
        if (message.stockGraduationTransfer !== undefined) {
            obj.stockGraduationTransfer = exports.StockGraduationTransfer.toJSON(message.stockGraduationTransfer);
        }
        if (message.stockCustomerAccountTransfer !== undefined) {
            obj.stockCustomerAccountTransfer = exports.StockCustomerAccountTransfer.toJSON(message.stockCustomerAccountTransfer);
        }
        if (message.subscription !== undefined) {
            obj.subscription = exports.Subscription.toJSON(message.subscription);
        }
        if (message.subscriptionRefund !== undefined) {
            obj.subscriptionRefund = exports.SubscriptionRefund.toJSON(message.subscriptionRefund);
        }
        if (message.transfer !== undefined) {
            obj.transfer = exports.Transfer.toJSON(message.transfer);
        }
        return obj;
    },
    create(base) {
        return exports.ActivityContext.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseActivityContext();
        message.achInCredit = (object.achInCredit !== undefined && object.achInCredit !== null)
            ? exports.AchInCredit.fromPartial(object.achInCredit)
            : undefined;
        message.achInCreditReversal =
            (object.achInCreditReversal !== undefined && object.achInCreditReversal !== null)
                ? exports.AchInCreditReversal.fromPartial(object.achInCreditReversal)
                : undefined;
        message.achInDebit = (object.achInDebit !== undefined && object.achInDebit !== null)
            ? exports.AchInDebit.fromPartial(object.achInDebit)
            : undefined;
        message.achInDebitReversal =
            (object.achInDebitReversal !== undefined && object.achInDebitReversal !== null)
                ? exports.AchInDebitReversal.fromPartial(object.achInDebitReversal)
                : undefined;
        message.achOutCredit = (object.achOutCredit !== undefined && object.achOutCredit !== null)
            ? exports.AchOutCredit.fromPartial(object.achOutCredit)
            : undefined;
        message.achOutCreditReversal =
            (object.achOutCreditReversal !== undefined && object.achOutCreditReversal !== null)
                ? exports.AchOutCreditReversal.fromPartial(object.achOutCreditReversal)
                : undefined;
        message.achOutDebit = (object.achOutDebit !== undefined && object.achOutDebit !== null)
            ? exports.AchOutDebit.fromPartial(object.achOutDebit)
            : undefined;
        message.achOutDebitReversal =
            (object.achOutDebitReversal !== undefined && object.achOutDebitReversal !== null)
                ? exports.AchOutDebitReversal.fromPartial(object.achOutDebitReversal)
                : undefined;
        message.atmWithdrawal = (object.atmWithdrawal !== undefined && object.atmWithdrawal !== null)
            ? exports.AtmWithdrawal.fromPartial(object.atmWithdrawal)
            : undefined;
        message.cardPayout = (object.cardPayout !== undefined && object.cardPayout !== null)
            ? exports.CardPayout.fromPartial(object.cardPayout)
            : undefined;
        message.cardPayoutFee = (object.cardPayoutFee !== undefined && object.cardPayoutFee !== null)
            ? exports.CardPayoutFee.fromPartial(object.cardPayoutFee)
            : undefined;
        message.cardPayoutFeeReversal =
            (object.cardPayoutFeeReversal !== undefined && object.cardPayoutFeeReversal !== null)
                ? exports.CardPayoutFeeReversal.fromPartial(object.cardPayoutFeeReversal)
                : undefined;
        message.cardPayoutReversal =
            (object.cardPayoutReversal !== undefined && object.cardPayoutReversal !== null)
                ? exports.CardPayoutReversal.fromPartial(object.cardPayoutReversal)
                : undefined;
        message.cashDeposit = (object.cashDeposit !== undefined && object.cashDeposit !== null)
            ? exports.CashDeposit.fromPartial(object.cashDeposit)
            : undefined;
        message.cashAdvance = (object.cashAdvance !== undefined && object.cashAdvance !== null)
            ? exports.CashAdvance.fromPartial(object.cashAdvance)
            : undefined;
        message.checkDeposit = (object.checkDeposit !== undefined && object.checkDeposit !== null)
            ? exports.CheckDeposit.fromPartial(object.checkDeposit)
            : undefined;
        message.checkDepositReturn =
            (object.checkDepositReturn !== undefined && object.checkDepositReturn !== null)
                ? exports.CheckDepositReturn.fromPartial(object.checkDepositReturn)
                : undefined;
        message.credit = (object.credit !== undefined && object.credit !== null)
            ? exports.Credit.fromPartial(object.credit)
            : undefined;
        message.creditBalancePayment =
            (object.creditBalancePayment !== undefined && object.creditBalancePayment !== null)
                ? exports.CreditBalancePayment.fromPartial(object.creditBalancePayment)
                : undefined;
        message.creditBillingFee =
            (object.creditBillingFee !== undefined && object.creditBillingFee !== null)
                ? exports.CreditBillingFee.fromPartial(object.creditBillingFee)
                : undefined;
        message.creditBillingInterest =
            (object.creditBillingInterest !== undefined && object.creditBillingInterest !== null)
                ? exports.CreditBillingInterest.fromPartial(object.creditBillingInterest)
                : undefined;
        message.cryptoTrade = (object.cryptoTrade !== undefined && object.cryptoTrade !== null)
            ? exports.CryptoTrade.fromPartial(object.cryptoTrade)
            : undefined;
        message.cryptoTradeTransfer =
            (object.cryptoTradeTransfer !== undefined && object.cryptoTradeTransfer !== null)
                ? exports.CryptoTradeTransfer.fromPartial(object.cryptoTradeTransfer)
                : undefined;
        message.debit = (object.debit !== undefined && object.debit !== null)
            ? exports.Debit.fromPartial(object.debit)
            : undefined;
        message.dispute = (object.dispute !== undefined && object.dispute !== null)
            ? exports.Dispute.fromPartial(object.dispute)
            : undefined;
        message.disputeReversal =
            (object.disputeReversal !== undefined && object.disputeReversal !== null)
                ? exports.DisputeReversal.fromPartial(object.disputeReversal)
                : undefined;
        message.fee = (object.fee !== undefined && object.fee !== null)
            ? exports.FeePayment.fromPartial(object.fee)
            : undefined;
        message.funding = (object.funding !== undefined && object.funding !== null)
            ? exports.Funding.fromPartial(object.funding)
            : undefined;
        message.fundingDispute = (object.fundingDispute !== undefined && object.fundingDispute !== null)
            ? exports.FundingDispute.fromPartial(object.fundingDispute)
            : undefined;
        message.fundingDisputeReversal =
            (object.fundingDisputeReversal !== undefined && object.fundingDisputeReversal !== null)
                ? exports.FundingDisputeReversal.fromPartial(object.fundingDisputeReversal)
                : undefined;
        message.fundingFee = (object.fundingFee !== undefined && object.fundingFee !== null)
            ? exports.FundingFee.fromPartial(object.fundingFee)
            : undefined;
        message.fundingFeeReversal =
            (object.fundingFeeReversal !== undefined && object.fundingFeeReversal !== null)
                ? exports.FundingFeeReversal.fromPartial(object.fundingFeeReversal)
                : undefined;
        message.fundingReversal =
            (object.fundingReversal !== undefined && object.fundingReversal !== null)
                ? exports.FundingReversal.fromPartial(object.fundingReversal)
                : undefined;
        message.giftCardPointsRedeem =
            (object.giftCardPointsRedeem !== undefined && object.giftCardPointsRedeem !== null)
                ? exports.GiftCardPointsRedeem.fromPartial(object.giftCardPointsRedeem)
                : undefined;
        message.giftCardPointsRedeemReversal =
            (object.giftCardPointsRedeemReversal !== undefined &&
                object.giftCardPointsRedeemReversal !== null)
                ? exports.GiftCardPointsRedeemReversal.fromPartial(object.giftCardPointsRedeemReversal)
                : undefined;
        message.installmentLoanBalanceTransfer =
            (object.installmentLoanBalanceTransfer !== undefined &&
                object.installmentLoanBalanceTransfer !== null)
                ? exports.InstallmentLoanBalanceTransfer.fromPartial(object.installmentLoanBalanceTransfer)
                : undefined;
        message.installmentLoanFunding =
            (object.installmentLoanFunding !== undefined && object.installmentLoanFunding !== null)
                ? exports.InstallmentLoanFunding.fromPartial(object.installmentLoanFunding)
                : undefined;
        message.installmentLoanPayment =
            (object.installmentLoanPayment !== undefined && object.installmentLoanPayment !== null)
                ? exports.InstallmentLoanPayment.fromPartial(object.installmentLoanPayment)
                : undefined;
        message.offerReward = (object.offerReward !== undefined && object.offerReward !== null)
            ? exports.OfferReward.fromPartial(object.offerReward)
            : undefined;
        message.p2p = (object.p2p !== undefined && object.p2p !== null)
            ? exports.P2P.fromPartial(object.p2p)
            : undefined;
        message.p2pReversal = (object.p2pReversal !== undefined && object.p2pReversal !== null)
            ? exports.P2PReversal.fromPartial(object.p2pReversal)
            : undefined;
        message.pointsRedeem = (object.pointsRedeem !== undefined && object.pointsRedeem !== null)
            ? exports.PointsRedeem.fromPartial(object.pointsRedeem)
            : undefined;
        message.pointsReward = (object.pointsReward !== undefined && object.pointsReward !== null)
            ? exports.PointsReward.fromPartial(object.pointsReward)
            : undefined;
        message.purchase = (object.purchase !== undefined && object.purchase !== null)
            ? exports.Purchase.fromPartial(object.purchase)
            : undefined;
        message.referral = (object.referral !== undefined && object.referral !== null)
            ? exports.Referral.fromPartial(object.referral)
            : undefined;
        message.refund = (object.refund !== undefined && object.refund !== null)
            ? exports.Refund.fromPartial(object.refund)
            : undefined;
        message.savingsInterest =
            (object.savingsInterest !== undefined && object.savingsInterest !== null)
                ? exports.SavingsInterest.fromPartial(object.savingsInterest)
                : undefined;
        message.savingsMatch = (object.savingsMatch !== undefined && object.savingsMatch !== null)
            ? exports.SavingsMatch.fromPartial(object.savingsMatch)
            : undefined;
        message.stockCorporateAction =
            (object.stockCorporateAction !== undefined && object.stockCorporateAction !== null)
                ? exports.StockCorporateAction.fromPartial(object.stockCorporateAction)
                : undefined;
        message.stockCorporateActionTransfer =
            (object.stockCorporateActionTransfer !== undefined &&
                object.stockCorporateActionTransfer !== null)
                ? exports.StockCorporateActionTransfer.fromPartial(object.stockCorporateActionTransfer)
                : undefined;
        message.stockFees = (object.stockFees !== undefined && object.stockFees !== null)
            ? exports.StockFees.fromPartial(object.stockFees)
            : undefined;
        message.stockInterestAdjustment =
            (object.stockInterestAdjustment !== undefined && object.stockInterestAdjustment !== null)
                ? exports.StockInterestAdjustment.fromPartial(object.stockInterestAdjustment)
                : undefined;
        message.stockTrade = (object.stockTrade !== undefined && object.stockTrade !== null)
            ? exports.StockTrade.fromPartial(object.stockTrade)
            : undefined;
        message.stockTradeTransfer =
            (object.stockTradeTransfer !== undefined && object.stockTradeTransfer !== null)
                ? exports.StockTradeTransfer.fromPartial(object.stockTradeTransfer)
                : undefined;
        message.stockGraduationTransfer =
            (object.stockGraduationTransfer !== undefined && object.stockGraduationTransfer !== null)
                ? exports.StockGraduationTransfer.fromPartial(object.stockGraduationTransfer)
                : undefined;
        message.stockCustomerAccountTransfer =
            (object.stockCustomerAccountTransfer !== undefined &&
                object.stockCustomerAccountTransfer !== null)
                ? exports.StockCustomerAccountTransfer.fromPartial(object.stockCustomerAccountTransfer)
                : undefined;
        message.subscription = (object.subscription !== undefined && object.subscription !== null)
            ? exports.Subscription.fromPartial(object.subscription)
            : undefined;
        message.subscriptionRefund =
            (object.subscriptionRefund !== undefined && object.subscriptionRefund !== null)
                ? exports.SubscriptionRefund.fromPartial(object.subscriptionRefund)
                : undefined;
        message.transfer = (object.transfer !== undefined && object.transfer !== null)
            ? exports.Transfer.fromPartial(object.transfer)
            : undefined;
        return message;
    },
};
function createBaseAchInCredit() {
    return {
        parties: undefined,
        effectiveDate: undefined,
        type: payment_ach_in_1.AchInPaymentType.INVALID_ACH_IN_PAYMENT_TYPE,
        daysEarly: 0,
    };
}
exports.AchInCredit = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.parties)) {
            message.parties = exports.AchInParties.fromJSON(object.parties);
        }
        if (isSet(object.effectiveDate)) {
            message.effectiveDate = date_1.LocalDate.fromJSON(object.effectiveDate);
        }
        if (isSet(object.type)) {
            message.type = (0, payment_ach_in_1.achInPaymentTypeFromJSON)(object.type);
        }
        if (isSet(object.daysEarly)) {
            message.daysEarly = globalThis.Number(object.daysEarly);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.parties !== undefined) {
            obj.parties = exports.AchInParties.toJSON(message.parties);
        }
        if (message.effectiveDate !== undefined) {
            obj.effectiveDate = date_1.LocalDate.toJSON(message.effectiveDate);
        }
        if (message.type !== undefined && message.type !== payment_ach_in_1.AchInPaymentType.INVALID_ACH_IN_PAYMENT_TYPE) {
            obj.type = (0, payment_ach_in_1.achInPaymentTypeToJSON)(message.type);
        }
        if (message.daysEarly !== undefined && message.daysEarly !== 0) {
            obj.daysEarly = Math.round(message.daysEarly);
        }
        return obj;
    },
    create(base) {
        return exports.AchInCredit.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAchInCredit();
        message.parties = (object.parties !== undefined && object.parties !== null)
            ? exports.AchInParties.fromPartial(object.parties)
            : undefined;
        message.effectiveDate = (object.effectiveDate !== undefined && object.effectiveDate !== null)
            ? date_1.LocalDate.fromPartial(object.effectiveDate)
            : undefined;
        message.type = object.type ?? payment_ach_in_1.AchInPaymentType.INVALID_ACH_IN_PAYMENT_TYPE;
        message.daysEarly = object.daysEarly ?? 0;
        return message;
    },
};
function createBaseAchInCreditReversal() {
    return { parties: undefined };
}
exports.AchInCreditReversal = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.parties)) {
            message.parties = exports.AchInParties.fromJSON(object.parties);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.parties !== undefined) {
            obj.parties = exports.AchInParties.toJSON(message.parties);
        }
        return obj;
    },
    create(base) {
        return exports.AchInCreditReversal.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAchInCreditReversal();
        message.parties = (object.parties !== undefined && object.parties !== null)
            ? exports.AchInParties.fromPartial(object.parties)
            : undefined;
        return message;
    },
};
function createBaseAchInDebit() {
    return { parties: undefined };
}
exports.AchInDebit = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.parties)) {
            message.parties = exports.AchInParties.fromJSON(object.parties);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.parties !== undefined) {
            obj.parties = exports.AchInParties.toJSON(message.parties);
        }
        return obj;
    },
    create(base) {
        return exports.AchInDebit.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAchInDebit();
        message.parties = (object.parties !== undefined && object.parties !== null)
            ? exports.AchInParties.fromPartial(object.parties)
            : undefined;
        return message;
    },
};
function createBaseAchInDebitReversal() {
    return { parties: undefined };
}
exports.AchInDebitReversal = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.parties)) {
            message.parties = exports.AchInParties.fromJSON(object.parties);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.parties !== undefined) {
            obj.parties = exports.AchInParties.toJSON(message.parties);
        }
        return obj;
    },
    create(base) {
        return exports.AchInDebitReversal.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAchInDebitReversal();
        message.parties = (object.parties !== undefined && object.parties !== null)
            ? exports.AchInParties.fromPartial(object.parties)
            : undefined;
        return message;
    },
};
function createBaseAchOutCredit() {
    return {
        reversalReason: payment_ach_out_1.AchOutPaymentContextReturnReason.INVALID_RETURN_REASON,
        errorCode: transaction_error_code_1.TransactionErrorCode.INVALID_ERROR_CODE,
        bank: undefined,
        isAutoReload: false,
        fee: undefined,
    };
}
exports.AchOutCredit = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.reversalReason)) {
            message.reversalReason = (0, payment_ach_out_1.achOutPaymentContextReturnReasonFromJSON)(object.reversalReason);
        }
        if (isSet(object.errorCode)) {
            message.errorCode = (0, transaction_error_code_1.transactionErrorCodeFromJSON)(object.errorCode);
        }
        if (isSet(object.bank)) {
            message.bank = exports.Bank.fromJSON(object.bank);
        }
        if (isSet(object.isAutoReload)) {
            message.isAutoReload = globalThis.Boolean(object.isAutoReload);
        }
        if (isSet(object.fee)) {
            message.fee = amount_1.Amount.fromJSON(object.fee);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.reversalReason !== undefined &&
            message.reversalReason !== payment_ach_out_1.AchOutPaymentContextReturnReason.INVALID_RETURN_REASON) {
            obj.reversalReason = (0, payment_ach_out_1.achOutPaymentContextReturnReasonToJSON)(message.reversalReason);
        }
        if (message.errorCode !== undefined &&
            message.errorCode !== transaction_error_code_1.TransactionErrorCode.INVALID_ERROR_CODE) {
            obj.errorCode = (0, transaction_error_code_1.transactionErrorCodeToJSON)(message.errorCode);
        }
        if (message.bank !== undefined) {
            obj.bank = exports.Bank.toJSON(message.bank);
        }
        if (message.isAutoReload !== undefined && message.isAutoReload !== false) {
            obj.isAutoReload = message.isAutoReload;
        }
        if (message.fee !== undefined) {
            obj.fee = amount_1.Amount.toJSON(message.fee);
        }
        return obj;
    },
    create(base) {
        return exports.AchOutCredit.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAchOutCredit();
        message.reversalReason = object.reversalReason ??
            payment_ach_out_1.AchOutPaymentContextReturnReason.INVALID_RETURN_REASON;
        message.errorCode = object.errorCode ?? transaction_error_code_1.TransactionErrorCode.INVALID_ERROR_CODE;
        message.bank = (object.bank !== undefined && object.bank !== null)
            ? exports.Bank.fromPartial(object.bank)
            : undefined;
        message.isAutoReload = object.isAutoReload ?? false;
        message.fee = (object.fee !== undefined && object.fee !== null)
            ? amount_1.Amount.fromPartial(object.fee)
            : undefined;
        return message;
    },
};
function createBaseAchOutCreditReversal() {
    return { reason: payment_ach_out_1.AchOutPaymentContextReturnReason.INVALID_RETURN_REASON, bank: undefined };
}
exports.AchOutCreditReversal = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.reason)) {
            message.reason = (0, payment_ach_out_1.achOutPaymentContextReturnReasonFromJSON)(object.reason);
        }
        if (isSet(object.bank)) {
            message.bank = exports.Bank.fromJSON(object.bank);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.reason !== undefined &&
            message.reason !== payment_ach_out_1.AchOutPaymentContextReturnReason.INVALID_RETURN_REASON) {
            obj.reason = (0, payment_ach_out_1.achOutPaymentContextReturnReasonToJSON)(message.reason);
        }
        if (message.bank !== undefined) {
            obj.bank = exports.Bank.toJSON(message.bank);
        }
        return obj;
    },
    create(base) {
        return exports.AchOutCreditReversal.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAchOutCreditReversal();
        message.reason = object.reason ?? payment_ach_out_1.AchOutPaymentContextReturnReason.INVALID_RETURN_REASON;
        message.bank = (object.bank !== undefined && object.bank !== null)
            ? exports.Bank.fromPartial(object.bank)
            : undefined;
        return message;
    },
};
function createBaseAchOutDebit() {
    return {
        reversalReason: payment_ach_out_1.AchOutPaymentContextReturnReason.INVALID_RETURN_REASON,
        errorCode: transaction_error_code_1.TransactionErrorCode.INVALID_ERROR_CODE,
        bank: undefined,
    };
}
exports.AchOutDebit = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.reversalReason)) {
            message.reversalReason = (0, payment_ach_out_1.achOutPaymentContextReturnReasonFromJSON)(object.reversalReason);
        }
        if (isSet(object.errorCode)) {
            message.errorCode = (0, transaction_error_code_1.transactionErrorCodeFromJSON)(object.errorCode);
        }
        if (isSet(object.bank)) {
            message.bank = exports.Bank.fromJSON(object.bank);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.reversalReason !== undefined &&
            message.reversalReason !== payment_ach_out_1.AchOutPaymentContextReturnReason.INVALID_RETURN_REASON) {
            obj.reversalReason = (0, payment_ach_out_1.achOutPaymentContextReturnReasonToJSON)(message.reversalReason);
        }
        if (message.errorCode !== undefined &&
            message.errorCode !== transaction_error_code_1.TransactionErrorCode.INVALID_ERROR_CODE) {
            obj.errorCode = (0, transaction_error_code_1.transactionErrorCodeToJSON)(message.errorCode);
        }
        if (message.bank !== undefined) {
            obj.bank = exports.Bank.toJSON(message.bank);
        }
        return obj;
    },
    create(base) {
        return exports.AchOutDebit.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAchOutDebit();
        message.reversalReason = object.reversalReason ??
            payment_ach_out_1.AchOutPaymentContextReturnReason.INVALID_RETURN_REASON;
        message.errorCode = object.errorCode ?? transaction_error_code_1.TransactionErrorCode.INVALID_ERROR_CODE;
        message.bank = (object.bank !== undefined && object.bank !== null)
            ? exports.Bank.fromPartial(object.bank)
            : undefined;
        return message;
    },
};
function createBaseAchOutDebitReversal() {
    return { reason: payment_ach_out_1.AchOutPaymentContextReturnReason.INVALID_RETURN_REASON, bank: undefined };
}
exports.AchOutDebitReversal = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.reason)) {
            message.reason = (0, payment_ach_out_1.achOutPaymentContextReturnReasonFromJSON)(object.reason);
        }
        if (isSet(object.bank)) {
            message.bank = exports.Bank.fromJSON(object.bank);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.reason !== undefined &&
            message.reason !== payment_ach_out_1.AchOutPaymentContextReturnReason.INVALID_RETURN_REASON) {
            obj.reason = (0, payment_ach_out_1.achOutPaymentContextReturnReasonToJSON)(message.reason);
        }
        if (message.bank !== undefined) {
            obj.bank = exports.Bank.toJSON(message.bank);
        }
        return obj;
    },
    create(base) {
        return exports.AchOutDebitReversal.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAchOutDebitReversal();
        message.reason = object.reason ?? payment_ach_out_1.AchOutPaymentContextReturnReason.INVALID_RETURN_REASON;
        message.bank = (object.bank !== undefined && object.bank !== null)
            ? exports.Bank.fromPartial(object.bank)
            : undefined;
        return message;
    },
};
function createBaseAtmWithdrawal() {
    return {
        card: undefined,
        merchant: undefined,
        fee: undefined,
        atmDescriptor: undefined,
        feeReimbursed: undefined,
        operatorFee: undefined,
        outOfNetworkFee: undefined,
        disputableTransactionId: '',
        isDisputed: false,
        disputeCloseReason: dispute_reason_1.DisputeCloseReason.INVALID_DISPUTE_CLOSE_REASON,
        isReversed: false,
    };
}
exports.AtmWithdrawal = {
    fromJSON(object) {
        const message = {
            isDisputed: isSet(object.isDisputed) ? globalThis.Boolean(object.isDisputed) : false,
        };
        if (isSet(object.card)) {
            message.card = exports.CardDetails.fromJSON(object.card);
        }
        if (isSet(object.merchant)) {
            message.merchant = exports.Merchant.fromJSON(object.merchant);
        }
        if (isSet(object.fee)) {
            message.fee = amount_1.Amount.fromJSON(object.fee);
        }
        if (isSet(object.atmDescriptor)) {
            message.atmDescriptor = atm_1.AtmDescriptor.fromJSON(object.atmDescriptor);
        }
        if (isSet(object.feeReimbursed)) {
            message.feeReimbursed = amount_1.Amount.fromJSON(object.feeReimbursed);
        }
        if (isSet(object.operatorFee)) {
            message.operatorFee = amount_1.Amount.fromJSON(object.operatorFee);
        }
        if (isSet(object.outOfNetworkFee)) {
            message.outOfNetworkFee = amount_1.Amount.fromJSON(object.outOfNetworkFee);
        }
        if (isSet(object.disputableTransactionId)) {
            message.disputableTransactionId = globalThis.String(object.disputableTransactionId);
        }
        if (isSet(object.disputeCloseReason)) {
            message.disputeCloseReason = (0, dispute_reason_1.disputeCloseReasonFromJSON)(object.disputeCloseReason);
        }
        if (isSet(object.isReversed)) {
            message.isReversed = globalThis.Boolean(object.isReversed);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.card !== undefined) {
            obj.card = exports.CardDetails.toJSON(message.card);
        }
        if (message.merchant !== undefined) {
            obj.merchant = exports.Merchant.toJSON(message.merchant);
        }
        if (message.fee !== undefined) {
            obj.fee = amount_1.Amount.toJSON(message.fee);
        }
        if (message.atmDescriptor !== undefined) {
            obj.atmDescriptor = atm_1.AtmDescriptor.toJSON(message.atmDescriptor);
        }
        if (message.feeReimbursed !== undefined) {
            obj.feeReimbursed = amount_1.Amount.toJSON(message.feeReimbursed);
        }
        if (message.operatorFee !== undefined) {
            obj.operatorFee = amount_1.Amount.toJSON(message.operatorFee);
        }
        if (message.outOfNetworkFee !== undefined) {
            obj.outOfNetworkFee = amount_1.Amount.toJSON(message.outOfNetworkFee);
        }
        if (message.disputableTransactionId !== undefined && message.disputableTransactionId !== '') {
            obj.disputableTransactionId = message.disputableTransactionId;
        }
        if (message.isDisputed !== false) {
            obj.isDisputed = message.isDisputed;
        }
        if (message.disputeCloseReason !== undefined &&
            message.disputeCloseReason !== dispute_reason_1.DisputeCloseReason.INVALID_DISPUTE_CLOSE_REASON) {
            obj.disputeCloseReason = (0, dispute_reason_1.disputeCloseReasonToJSON)(message.disputeCloseReason);
        }
        if (message.isReversed !== undefined && message.isReversed !== false) {
            obj.isReversed = message.isReversed;
        }
        return obj;
    },
    create(base) {
        return exports.AtmWithdrawal.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAtmWithdrawal();
        message.card = (object.card !== undefined && object.card !== null)
            ? exports.CardDetails.fromPartial(object.card)
            : undefined;
        message.merchant = (object.merchant !== undefined && object.merchant !== null)
            ? exports.Merchant.fromPartial(object.merchant)
            : undefined;
        message.fee = (object.fee !== undefined && object.fee !== null)
            ? amount_1.Amount.fromPartial(object.fee)
            : undefined;
        message.atmDescriptor = (object.atmDescriptor !== undefined && object.atmDescriptor !== null)
            ? atm_1.AtmDescriptor.fromPartial(object.atmDescriptor)
            : undefined;
        message.feeReimbursed = (object.feeReimbursed !== undefined && object.feeReimbursed !== null)
            ? amount_1.Amount.fromPartial(object.feeReimbursed)
            : undefined;
        message.operatorFee = (object.operatorFee !== undefined && object.operatorFee !== null)
            ? amount_1.Amount.fromPartial(object.operatorFee)
            : undefined;
        message.outOfNetworkFee =
            (object.outOfNetworkFee !== undefined && object.outOfNetworkFee !== null)
                ? amount_1.Amount.fromPartial(object.outOfNetworkFee)
                : undefined;
        message.disputableTransactionId = object.disputableTransactionId ?? '';
        message.isDisputed = object.isDisputed ?? false;
        message.disputeCloseReason = object.disputeCloseReason ??
            dispute_reason_1.DisputeCloseReason.INVALID_DISPUTE_CLOSE_REASON;
        message.isReversed = object.isReversed ?? false;
        return message;
    },
};
function createBaseCredit() {
    return { merchant: undefined, card: undefined };
}
exports.Credit = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.merchant)) {
            message.merchant = exports.Merchant.fromJSON(object.merchant);
        }
        if (isSet(object.card)) {
            message.card = exports.CardDetails.fromJSON(object.card);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.merchant !== undefined) {
            obj.merchant = exports.Merchant.toJSON(message.merchant);
        }
        if (message.card !== undefined) {
            obj.card = exports.CardDetails.toJSON(message.card);
        }
        return obj;
    },
    create(base) {
        return exports.Credit.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCredit();
        message.merchant = (object.merchant !== undefined && object.merchant !== null)
            ? exports.Merchant.fromPartial(object.merchant)
            : undefined;
        message.card = (object.card !== undefined && object.card !== null)
            ? exports.CardDetails.fromPartial(object.card)
            : undefined;
        return message;
    },
};
function createBaseDebit() {
    return {
        merchant: undefined,
        card: undefined,
        disputableTransactionId: '',
        isDisputed: false,
        disputeCloseReason: dispute_reason_1.DisputeCloseReason.INVALID_DISPUTE_CLOSE_REASON,
    };
}
exports.Debit = {
    fromJSON(object) {
        const message = {
            isDisputed: isSet(object.isDisputed) ? globalThis.Boolean(object.isDisputed) : false,
        };
        if (isSet(object.merchant)) {
            message.merchant = exports.Merchant.fromJSON(object.merchant);
        }
        if (isSet(object.card)) {
            message.card = exports.CardDetails.fromJSON(object.card);
        }
        if (isSet(object.disputableTransactionId)) {
            message.disputableTransactionId = globalThis.String(object.disputableTransactionId);
        }
        if (isSet(object.disputeCloseReason)) {
            message.disputeCloseReason = (0, dispute_reason_1.disputeCloseReasonFromJSON)(object.disputeCloseReason);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.merchant !== undefined) {
            obj.merchant = exports.Merchant.toJSON(message.merchant);
        }
        if (message.card !== undefined) {
            obj.card = exports.CardDetails.toJSON(message.card);
        }
        if (message.disputableTransactionId !== undefined && message.disputableTransactionId !== '') {
            obj.disputableTransactionId = message.disputableTransactionId;
        }
        if (message.isDisputed !== false) {
            obj.isDisputed = message.isDisputed;
        }
        if (message.disputeCloseReason !== undefined &&
            message.disputeCloseReason !== dispute_reason_1.DisputeCloseReason.INVALID_DISPUTE_CLOSE_REASON) {
            obj.disputeCloseReason = (0, dispute_reason_1.disputeCloseReasonToJSON)(message.disputeCloseReason);
        }
        return obj;
    },
    create(base) {
        return exports.Debit.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDebit();
        message.merchant = (object.merchant !== undefined && object.merchant !== null)
            ? exports.Merchant.fromPartial(object.merchant)
            : undefined;
        message.card = (object.card !== undefined && object.card !== null)
            ? exports.CardDetails.fromPartial(object.card)
            : undefined;
        message.disputableTransactionId = object.disputableTransactionId ?? '';
        message.isDisputed = object.isDisputed ?? false;
        message.disputeCloseReason = object.disputeCloseReason ??
            dispute_reason_1.DisputeCloseReason.INVALID_DISPUTE_CLOSE_REASON;
        return message;
    },
};
function createBaseDispute() {
    return { merchant: undefined, card: undefined };
}
exports.Dispute = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.merchant)) {
            message.merchant = exports.Merchant.fromJSON(object.merchant);
        }
        if (isSet(object.card)) {
            message.card = exports.CardDetails.fromJSON(object.card);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.merchant !== undefined) {
            obj.merchant = exports.Merchant.toJSON(message.merchant);
        }
        if (message.card !== undefined) {
            obj.card = exports.CardDetails.toJSON(message.card);
        }
        return obj;
    },
    create(base) {
        return exports.Dispute.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDispute();
        message.merchant = (object.merchant !== undefined && object.merchant !== null)
            ? exports.Merchant.fromPartial(object.merchant)
            : undefined;
        message.card = (object.card !== undefined && object.card !== null)
            ? exports.CardDetails.fromPartial(object.card)
            : undefined;
        return message;
    },
};
function createBaseDisputeReversal() {
    return { merchant: undefined, card: undefined };
}
exports.DisputeReversal = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.merchant)) {
            message.merchant = exports.Merchant.fromJSON(object.merchant);
        }
        if (isSet(object.card)) {
            message.card = exports.CardDetails.fromJSON(object.card);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.merchant !== undefined) {
            obj.merchant = exports.Merchant.toJSON(message.merchant);
        }
        if (message.card !== undefined) {
            obj.card = exports.CardDetails.toJSON(message.card);
        }
        return obj;
    },
    create(base) {
        return exports.DisputeReversal.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDisputeReversal();
        message.merchant = (object.merchant !== undefined && object.merchant !== null)
            ? exports.Merchant.fromPartial(object.merchant)
            : undefined;
        message.card = (object.card !== undefined && object.card !== null)
            ? exports.CardDetails.fromPartial(object.card)
            : undefined;
        return message;
    },
};
function createBasePurchase() {
    return {
        card: undefined,
        merchant: undefined,
        merchantDescriptor: undefined,
        disputableTransactionId: '',
        dispute: undefined,
        isDisputed: false,
        disputeCloseReason: dispute_reason_1.DisputeCloseReason.INVALID_DISPUTE_CLOSE_REASON,
        purchaseAmount: undefined,
        roundUp: undefined,
        installmentLoan: undefined,
        installmentLoanAccountId: '',
        movePurchase: undefined,
        isMovePurchaseEligible: false,
        isBlockable: false,
        isForeign: false,
        is3dsAuthenticated: false,
        breakdown: undefined,
        eventType: PurchaseEventType.INVALID_PURCHASE_EVENT_TYPE,
        atm: undefined,
        cardId: '',
        authorization: undefined,
        verifiedByFraudChallenge: false,
    };
}
exports.Purchase = {
    fromJSON(object) {
        const message = {
            isDisputed: isSet(object.isDisputed) ? globalThis.Boolean(object.isDisputed) : false,
            isBlockable: isSet(object.isBlockable) ? globalThis.Boolean(object.isBlockable) : false,
            isForeign: isSet(object.isForeign) ? globalThis.Boolean(object.isForeign) : false,
            is3dsAuthenticated: isSet(object.is3dsAuthenticated)
                ? globalThis.Boolean(object.is3dsAuthenticated)
                : false,
        };
        if (isSet(object.card)) {
            message.card = exports.CardDetails.fromJSON(object.card);
        }
        if (isSet(object.merchant)) {
            message.merchant = exports.Merchant.fromJSON(object.merchant);
        }
        if (isSet(object.merchantDescriptor)) {
            message.merchantDescriptor = merchant_1.MerchantDescriptor.fromJSON(object.merchantDescriptor);
        }
        if (isSet(object.disputableTransactionId)) {
            message.disputableTransactionId = globalThis.String(object.disputableTransactionId);
        }
        if (isSet(object.dispute)) {
            message.dispute = exports.DisputeState.fromJSON(object.dispute);
        }
        if (isSet(object.disputeCloseReason)) {
            message.disputeCloseReason = (0, dispute_reason_1.disputeCloseReasonFromJSON)(object.disputeCloseReason);
        }
        if (isSet(object.purchaseAmount)) {
            message.purchaseAmount = amount_1.Amount.fromJSON(object.purchaseAmount);
        }
        if (isSet(object.roundUp)) {
            message.roundUp = exports.PurchaseRoundUp.fromJSON(object.roundUp);
        }
        if (isSet(object.installmentLoan)) {
            message.installmentLoan = exports.PurchaseInstallmentLoan.fromJSON(object.installmentLoan);
        }
        if (isSet(object.installmentLoanAccountId)) {
            message.installmentLoanAccountId = globalThis.String(object.installmentLoanAccountId);
        }
        if (isSet(object.movePurchase)) {
            message.movePurchase = exports.PurchasePurchaseMove.fromJSON(object.movePurchase);
        }
        if (isSet(object.isMovePurchaseEligible)) {
            message.isMovePurchaseEligible = globalThis.Boolean(object.isMovePurchaseEligible);
        }
        if (isSet(object.breakdown)) {
            message.breakdown = exports.PurchaseBreakdown.fromJSON(object.breakdown);
        }
        if (isSet(object.eventType)) {
            message.eventType = purchaseEventTypeFromJSON(object.eventType);
        }
        if (isSet(object.atm)) {
            message.atm = exports.AtmPurchase.fromJSON(object.atm);
        }
        if (isSet(object.cardId)) {
            message.cardId = globalThis.String(object.cardId);
        }
        if (isSet(object.authorization)) {
            message.authorization = exports.Authorization.fromJSON(object.authorization);
        }
        if (isSet(object.verifiedByFraudChallenge)) {
            message.verifiedByFraudChallenge = globalThis.Boolean(object.verifiedByFraudChallenge);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.card !== undefined) {
            obj.card = exports.CardDetails.toJSON(message.card);
        }
        if (message.merchant !== undefined) {
            obj.merchant = exports.Merchant.toJSON(message.merchant);
        }
        if (message.merchantDescriptor !== undefined) {
            obj.merchantDescriptor = merchant_1.MerchantDescriptor.toJSON(message.merchantDescriptor);
        }
        if (message.disputableTransactionId !== undefined && message.disputableTransactionId !== '') {
            obj.disputableTransactionId = message.disputableTransactionId;
        }
        if (message.dispute !== undefined) {
            obj.dispute = exports.DisputeState.toJSON(message.dispute);
        }
        if (message.isDisputed !== false) {
            obj.isDisputed = message.isDisputed;
        }
        if (message.disputeCloseReason !== undefined &&
            message.disputeCloseReason !== dispute_reason_1.DisputeCloseReason.INVALID_DISPUTE_CLOSE_REASON) {
            obj.disputeCloseReason = (0, dispute_reason_1.disputeCloseReasonToJSON)(message.disputeCloseReason);
        }
        if (message.purchaseAmount !== undefined) {
            obj.purchaseAmount = amount_1.Amount.toJSON(message.purchaseAmount);
        }
        if (message.roundUp !== undefined) {
            obj.roundUp = exports.PurchaseRoundUp.toJSON(message.roundUp);
        }
        if (message.installmentLoan !== undefined) {
            obj.installmentLoan = exports.PurchaseInstallmentLoan.toJSON(message.installmentLoan);
        }
        if (message.installmentLoanAccountId !== undefined && message.installmentLoanAccountId !== '') {
            obj.installmentLoanAccountId = message.installmentLoanAccountId;
        }
        if (message.movePurchase !== undefined) {
            obj.movePurchase = exports.PurchasePurchaseMove.toJSON(message.movePurchase);
        }
        if (message.isMovePurchaseEligible !== undefined && message.isMovePurchaseEligible !== false) {
            obj.isMovePurchaseEligible = message.isMovePurchaseEligible;
        }
        if (message.isBlockable !== false) {
            obj.isBlockable = message.isBlockable;
        }
        if (message.isForeign !== false) {
            obj.isForeign = message.isForeign;
        }
        if (message.is3dsAuthenticated !== false) {
            obj.is3dsAuthenticated = message.is3dsAuthenticated;
        }
        if (message.breakdown !== undefined) {
            obj.breakdown = exports.PurchaseBreakdown.toJSON(message.breakdown);
        }
        if (message.eventType !== undefined &&
            message.eventType !== PurchaseEventType.INVALID_PURCHASE_EVENT_TYPE) {
            obj.eventType = purchaseEventTypeToJSON(message.eventType);
        }
        if (message.atm !== undefined) {
            obj.atm = exports.AtmPurchase.toJSON(message.atm);
        }
        if (message.cardId !== undefined && message.cardId !== '') {
            obj.cardId = message.cardId;
        }
        if (message.authorization !== undefined) {
            obj.authorization = exports.Authorization.toJSON(message.authorization);
        }
        if (message.verifiedByFraudChallenge !== undefined && message.verifiedByFraudChallenge !== false) {
            obj.verifiedByFraudChallenge = message.verifiedByFraudChallenge;
        }
        return obj;
    },
    create(base) {
        return exports.Purchase.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePurchase();
        message.card = (object.card !== undefined && object.card !== null)
            ? exports.CardDetails.fromPartial(object.card)
            : undefined;
        message.merchant = (object.merchant !== undefined && object.merchant !== null)
            ? exports.Merchant.fromPartial(object.merchant)
            : undefined;
        message.merchantDescriptor =
            (object.merchantDescriptor !== undefined && object.merchantDescriptor !== null)
                ? merchant_1.MerchantDescriptor.fromPartial(object.merchantDescriptor)
                : undefined;
        message.disputableTransactionId = object.disputableTransactionId ?? '';
        message.dispute = (object.dispute !== undefined && object.dispute !== null)
            ? exports.DisputeState.fromPartial(object.dispute)
            : undefined;
        message.isDisputed = object.isDisputed ?? false;
        message.disputeCloseReason = object.disputeCloseReason ??
            dispute_reason_1.DisputeCloseReason.INVALID_DISPUTE_CLOSE_REASON;
        message.purchaseAmount = (object.purchaseAmount !== undefined && object.purchaseAmount !== null)
            ? amount_1.Amount.fromPartial(object.purchaseAmount)
            : undefined;
        message.roundUp = (object.roundUp !== undefined && object.roundUp !== null)
            ? exports.PurchaseRoundUp.fromPartial(object.roundUp)
            : undefined;
        message.installmentLoan =
            (object.installmentLoan !== undefined && object.installmentLoan !== null)
                ? exports.PurchaseInstallmentLoan.fromPartial(object.installmentLoan)
                : undefined;
        message.installmentLoanAccountId = object.installmentLoanAccountId ?? '';
        message.movePurchase = (object.movePurchase !== undefined && object.movePurchase !== null)
            ? exports.PurchasePurchaseMove.fromPartial(object.movePurchase)
            : undefined;
        message.isMovePurchaseEligible = object.isMovePurchaseEligible ?? false;
        message.isBlockable = object.isBlockable ?? false;
        message.isForeign = object.isForeign ?? false;
        message.is3dsAuthenticated = object.is3dsAuthenticated ?? false;
        message.breakdown = (object.breakdown !== undefined && object.breakdown !== null)
            ? exports.PurchaseBreakdown.fromPartial(object.breakdown)
            : undefined;
        message.eventType = object.eventType ?? PurchaseEventType.INVALID_PURCHASE_EVENT_TYPE;
        message.atm = (object.atm !== undefined && object.atm !== null)
            ? exports.AtmPurchase.fromPartial(object.atm)
            : undefined;
        message.cardId = object.cardId ?? '';
        message.authorization = (object.authorization !== undefined && object.authorization !== null)
            ? exports.Authorization.fromPartial(object.authorization)
            : undefined;
        message.verifiedByFraudChallenge = object.verifiedByFraudChallenge ?? false;
        return message;
    },
};
function createBasePurchaseInstallmentLoan() {
    return { accountId: '', totalLent: undefined };
}
exports.PurchaseInstallmentLoan = {
    fromJSON(object) {
        const message = {
            accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : '',
        };
        if (isSet(object.totalLent)) {
            message.totalLent = amount_1.Amount.fromJSON(object.totalLent);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.accountId !== '') {
            obj.accountId = message.accountId;
        }
        if (message.totalLent !== undefined) {
            obj.totalLent = amount_1.Amount.toJSON(message.totalLent);
        }
        return obj;
    },
    create(base) {
        return exports.PurchaseInstallmentLoan.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePurchaseInstallmentLoan();
        message.accountId = object.accountId ?? '';
        message.totalLent = (object.totalLent !== undefined && object.totalLent !== null)
            ? amount_1.Amount.fromPartial(object.totalLent)
            : undefined;
        return message;
    },
};
function createBasePurchaseRoundUp() {
    return {
        amount: amount_1.Amount.fromPartial({}),
        savingsGoal: undefined,
        stock: undefined,
        crypto: undefined,
        createdAtMs: '0',
    };
}
exports.PurchaseRoundUp = {
    fromJSON(object) {
        const message = {
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
            createdAtMs: isSet(object.createdAtMs) ? globalThis.String(object.createdAtMs) : '0',
        };
        if (isSet(object.savingsGoal)) {
            message.savingsGoal = savings_goal_1.SavingsGoal.fromJSON(object.savingsGoal);
        }
        if (isSet(object.stock)) {
            message.stock = exports.PurchaseRoundUpStockContext.fromJSON(object.stock);
        }
        if (isSet(object.crypto)) {
            message.crypto = exports.PurchaseRoundUpCryptoContext.fromJSON(object.crypto);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.savingsGoal !== undefined) {
            obj.savingsGoal = savings_goal_1.SavingsGoal.toJSON(message.savingsGoal);
        }
        if (message.stock !== undefined) {
            obj.stock = exports.PurchaseRoundUpStockContext.toJSON(message.stock);
        }
        if (message.crypto !== undefined) {
            obj.crypto = exports.PurchaseRoundUpCryptoContext.toJSON(message.crypto);
        }
        if (message.createdAtMs !== '0') {
            obj.createdAtMs = message.createdAtMs;
        }
        return obj;
    },
    create(base) {
        return exports.PurchaseRoundUp.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePurchaseRoundUp();
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        message.savingsGoal = (object.savingsGoal !== undefined && object.savingsGoal !== null)
            ? savings_goal_1.SavingsGoal.fromPartial(object.savingsGoal)
            : undefined;
        message.stock = (object.stock !== undefined && object.stock !== null)
            ? exports.PurchaseRoundUpStockContext.fromPartial(object.stock)
            : undefined;
        message.crypto = (object.crypto !== undefined && object.crypto !== null)
            ? exports.PurchaseRoundUpCryptoContext.fromPartial(object.crypto)
            : undefined;
        message.createdAtMs = object.createdAtMs ?? '0';
        return message;
    },
};
function createBasePurchasePurchaseMove() {
    return { destinationId: '', rolloverAmount: undefined };
}
exports.PurchasePurchaseMove = {
    fromJSON(object) {
        const message = {
            destinationId: isSet(object.destinationId) ? globalThis.String(object.destinationId) : '',
        };
        if (isSet(object.rolloverAmount)) {
            message.rolloverAmount = amount_1.Amount.fromJSON(object.rolloverAmount);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.destinationId !== '') {
            obj.destinationId = message.destinationId;
        }
        if (message.rolloverAmount !== undefined) {
            obj.rolloverAmount = amount_1.Amount.toJSON(message.rolloverAmount);
        }
        return obj;
    },
    create(base) {
        return exports.PurchasePurchaseMove.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePurchasePurchaseMove();
        message.destinationId = object.destinationId ?? '';
        message.rolloverAmount = (object.rolloverAmount !== undefined && object.rolloverAmount !== null)
            ? amount_1.Amount.fromPartial(object.rolloverAmount)
            : undefined;
        return message;
    },
};
function createBasePurchaseRoundUpStockContext() {
    return {
        instrument: financial_instrument_1.FinancialInstrument.fromPartial({}),
        orderStatus: stock_order_1.OrderStatus.INVALID_ORDER_STATUS,
    };
}
exports.PurchaseRoundUpStockContext = {
    fromJSON(object) {
        const message = {
            instrument: isSet(object.instrument)
                ? financial_instrument_1.FinancialInstrument.fromJSON(object.instrument)
                : financial_instrument_1.FinancialInstrument.fromPartial({}),
            orderStatus: isSet(object.orderStatus)
                ? (0, stock_order_1.orderStatusFromJSON)(object.orderStatus)
                : stock_order_1.OrderStatus.INVALID_ORDER_STATUS,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.instrument !== undefined) {
            obj.instrument = financial_instrument_1.FinancialInstrument.toJSON(message.instrument);
        }
        if (message.orderStatus !== stock_order_1.OrderStatus.INVALID_ORDER_STATUS) {
            obj.orderStatus = (0, stock_order_1.orderStatusToJSON)(message.orderStatus);
        }
        return obj;
    },
    create(base) {
        return exports.PurchaseRoundUpStockContext.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePurchaseRoundUpStockContext();
        message.instrument = (object.instrument !== undefined && object.instrument !== null)
            ? financial_instrument_1.FinancialInstrument.fromPartial(object.instrument)
            : financial_instrument_1.FinancialInstrument.fromPartial({});
        message.orderStatus = object.orderStatus ?? stock_order_1.OrderStatus.INVALID_ORDER_STATUS;
        return message;
    },
};
function createBasePurchaseRoundUpCryptoContext() {
    return { currency: digital_currency_1.DigitalCurrency.fromPartial({}) };
}
exports.PurchaseRoundUpCryptoContext = {
    fromJSON(object) {
        const message = {
            currency: isSet(object.currency)
                ? digital_currency_1.DigitalCurrency.fromJSON(object.currency)
                : digital_currency_1.DigitalCurrency.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.currency !== undefined) {
            obj.currency = digital_currency_1.DigitalCurrency.toJSON(message.currency);
        }
        return obj;
    },
    create(base) {
        return exports.PurchaseRoundUpCryptoContext.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePurchaseRoundUpCryptoContext();
        message.currency = (object.currency !== undefined && object.currency !== null)
            ? digital_currency_1.DigitalCurrency.fromPartial(object.currency)
            : digital_currency_1.DigitalCurrency.fromPartial({});
        return message;
    },
};
function createBaseAuthorization() {
    return { amount: amount_1.Amount.fromPartial({}), timeMs: '0' };
}
exports.Authorization = {
    fromJSON(object) {
        const message = {
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
            timeMs: isSet(object.timeMs) ? globalThis.String(object.timeMs) : '0',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.timeMs !== '0') {
            obj.timeMs = message.timeMs;
        }
        return obj;
    },
    create(base) {
        return exports.Authorization.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAuthorization();
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        message.timeMs = object.timeMs ?? '0';
        return message;
    },
};
function createBasePurchaseBreakdown() {
    return { primary: exports.PurchaseAccount.fromPartial({}), secondary: undefined };
}
exports.PurchaseBreakdown = {
    fromJSON(object) {
        const message = {
            primary: isSet(object.primary)
                ? exports.PurchaseAccount.fromJSON(object.primary)
                : exports.PurchaseAccount.fromPartial({}),
        };
        if (isSet(object.secondary)) {
            message.secondary = exports.PurchaseAccount.fromJSON(object.secondary);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.primary !== undefined) {
            obj.primary = exports.PurchaseAccount.toJSON(message.primary);
        }
        if (message.secondary !== undefined) {
            obj.secondary = exports.PurchaseAccount.toJSON(message.secondary);
        }
        return obj;
    },
    create(base) {
        return exports.PurchaseBreakdown.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePurchaseBreakdown();
        message.primary = (object.primary !== undefined && object.primary !== null)
            ? exports.PurchaseAccount.fromPartial(object.primary)
            : exports.PurchaseAccount.fromPartial({});
        message.secondary = (object.secondary !== undefined && object.secondary !== null)
            ? exports.PurchaseAccount.fromPartial(object.secondary)
            : undefined;
        return message;
    },
};
function createBasePurchaseAccount() {
    return {
        accountId: '',
        type: PurchaseAccountType.INVALID_PURCHASE_ACCOUNT_TYPE,
        amount: amount_1.Amount.fromPartial({}),
    };
}
exports.PurchaseAccount = {
    fromJSON(object) {
        const message = {
            accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : '',
            type: isSet(object.type)
                ? purchaseAccountTypeFromJSON(object.type)
                : PurchaseAccountType.INVALID_PURCHASE_ACCOUNT_TYPE,
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.accountId !== '') {
            obj.accountId = message.accountId;
        }
        if (message.type !== PurchaseAccountType.INVALID_PURCHASE_ACCOUNT_TYPE) {
            obj.type = purchaseAccountTypeToJSON(message.type);
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        return obj;
    },
    create(base) {
        return exports.PurchaseAccount.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePurchaseAccount();
        message.accountId = object.accountId ?? '';
        message.type = object.type ?? PurchaseAccountType.INVALID_PURCHASE_ACCOUNT_TYPE;
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        return message;
    },
};
function createBaseDisputeState() {
    return {
        isResolved: false,
        openReason: dispute_reason_1.DisputeReason.INVALID_DISPUTE_REASON,
        closeReason: dispute_reason_1.DisputeCloseReason.INVALID_DISPUTE_CLOSE_REASON,
        isRetractable: false,
    };
}
exports.DisputeState = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.isResolved)) {
            message.isResolved = globalThis.Boolean(object.isResolved);
        }
        if (isSet(object.openReason)) {
            message.openReason = (0, dispute_reason_1.disputeReasonFromJSON)(object.openReason);
        }
        if (isSet(object.closeReason)) {
            message.closeReason = (0, dispute_reason_1.disputeCloseReasonFromJSON)(object.closeReason);
        }
        if (isSet(object.isRetractable)) {
            message.isRetractable = globalThis.Boolean(object.isRetractable);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.isResolved !== undefined && message.isResolved !== false) {
            obj.isResolved = message.isResolved;
        }
        if (message.openReason !== undefined &&
            message.openReason !== dispute_reason_1.DisputeReason.INVALID_DISPUTE_REASON) {
            obj.openReason = (0, dispute_reason_1.disputeReasonToJSON)(message.openReason);
        }
        if (message.closeReason !== undefined &&
            message.closeReason !== dispute_reason_1.DisputeCloseReason.INVALID_DISPUTE_CLOSE_REASON) {
            obj.closeReason = (0, dispute_reason_1.disputeCloseReasonToJSON)(message.closeReason);
        }
        if (message.isRetractable !== undefined && message.isRetractable !== false) {
            obj.isRetractable = message.isRetractable;
        }
        return obj;
    },
    create(base) {
        return exports.DisputeState.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseDisputeState();
        message.isResolved = object.isResolved ?? false;
        message.openReason = object.openReason ?? dispute_reason_1.DisputeReason.INVALID_DISPUTE_REASON;
        message.closeReason = object.closeReason ?? dispute_reason_1.DisputeCloseReason.INVALID_DISPUTE_CLOSE_REASON;
        message.isRetractable = object.isRetractable ?? false;
        return message;
    },
};
function createBaseAtmPurchase() {
    return {
        atmDescriptor: atm_1.AtmDescriptor.fromPartial({}),
        fee: undefined,
        feeReimbursed: undefined,
        operatorFee: undefined,
        outOfNetworkFee: undefined,
    };
}
exports.AtmPurchase = {
    fromJSON(object) {
        const message = {
            atmDescriptor: isSet(object.atmDescriptor)
                ? atm_1.AtmDescriptor.fromJSON(object.atmDescriptor)
                : atm_1.AtmDescriptor.fromPartial({}),
        };
        if (isSet(object.fee)) {
            message.fee = amount_1.Amount.fromJSON(object.fee);
        }
        if (isSet(object.feeReimbursed)) {
            message.feeReimbursed = amount_1.Amount.fromJSON(object.feeReimbursed);
        }
        if (isSet(object.operatorFee)) {
            message.operatorFee = amount_1.Amount.fromJSON(object.operatorFee);
        }
        if (isSet(object.outOfNetworkFee)) {
            message.outOfNetworkFee = amount_1.Amount.fromJSON(object.outOfNetworkFee);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.atmDescriptor !== undefined) {
            obj.atmDescriptor = atm_1.AtmDescriptor.toJSON(message.atmDescriptor);
        }
        if (message.fee !== undefined) {
            obj.fee = amount_1.Amount.toJSON(message.fee);
        }
        if (message.feeReimbursed !== undefined) {
            obj.feeReimbursed = amount_1.Amount.toJSON(message.feeReimbursed);
        }
        if (message.operatorFee !== undefined) {
            obj.operatorFee = amount_1.Amount.toJSON(message.operatorFee);
        }
        if (message.outOfNetworkFee !== undefined) {
            obj.outOfNetworkFee = amount_1.Amount.toJSON(message.outOfNetworkFee);
        }
        return obj;
    },
    create(base) {
        return exports.AtmPurchase.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAtmPurchase();
        message.atmDescriptor = (object.atmDescriptor !== undefined && object.atmDescriptor !== null)
            ? atm_1.AtmDescriptor.fromPartial(object.atmDescriptor)
            : atm_1.AtmDescriptor.fromPartial({});
        message.fee = (object.fee !== undefined && object.fee !== null)
            ? amount_1.Amount.fromPartial(object.fee)
            : undefined;
        message.feeReimbursed = (object.feeReimbursed !== undefined && object.feeReimbursed !== null)
            ? amount_1.Amount.fromPartial(object.feeReimbursed)
            : undefined;
        message.operatorFee = (object.operatorFee !== undefined && object.operatorFee !== null)
            ? amount_1.Amount.fromPartial(object.operatorFee)
            : undefined;
        message.outOfNetworkFee =
            (object.outOfNetworkFee !== undefined && object.outOfNetworkFee !== null)
                ? amount_1.Amount.fromPartial(object.outOfNetworkFee)
                : undefined;
        return message;
    },
};
function createBaseRefund() {
    return { merchant: undefined, card: undefined };
}
exports.Refund = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.merchant)) {
            message.merchant = exports.Merchant.fromJSON(object.merchant);
        }
        if (isSet(object.card)) {
            message.card = exports.CardDetails.fromJSON(object.card);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.merchant !== undefined) {
            obj.merchant = exports.Merchant.toJSON(message.merchant);
        }
        if (message.card !== undefined) {
            obj.card = exports.CardDetails.toJSON(message.card);
        }
        return obj;
    },
    create(base) {
        return exports.Refund.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRefund();
        message.merchant = (object.merchant !== undefined && object.merchant !== null)
            ? exports.Merchant.fromPartial(object.merchant)
            : undefined;
        message.card = (object.card !== undefined && object.card !== null)
            ? exports.CardDetails.fromPartial(object.card)
            : undefined;
        return message;
    },
};
function createBaseCashDeposit() {
    return {
        merchant: undefined,
        errorCode: transaction_error_code_1.TransactionErrorCode.INVALID_ERROR_CODE,
        cashDepositDescriptor: undefined,
        barcode: '',
        fee: undefined,
    };
}
exports.CashDeposit = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.merchant)) {
            message.merchant = exports.Merchant.fromJSON(object.merchant);
        }
        if (isSet(object.errorCode)) {
            message.errorCode = (0, transaction_error_code_1.transactionErrorCodeFromJSON)(object.errorCode);
        }
        if (isSet(object.cashDepositDescriptor)) {
            message.cashDepositDescriptor = payment_cash_deposit_1.CashDepositDescriptor.fromJSON(object.cashDepositDescriptor);
        }
        if (isSet(object.barcode)) {
            message.barcode = globalThis.String(object.barcode);
        }
        if (isSet(object.fee)) {
            message.fee = amount_1.Amount.fromJSON(object.fee);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.merchant !== undefined) {
            obj.merchant = exports.Merchant.toJSON(message.merchant);
        }
        if (message.errorCode !== undefined &&
            message.errorCode !== transaction_error_code_1.TransactionErrorCode.INVALID_ERROR_CODE) {
            obj.errorCode = (0, transaction_error_code_1.transactionErrorCodeToJSON)(message.errorCode);
        }
        if (message.cashDepositDescriptor !== undefined) {
            obj.cashDepositDescriptor = payment_cash_deposit_1.CashDepositDescriptor.toJSON(message.cashDepositDescriptor);
        }
        if (message.barcode !== undefined && message.barcode !== '') {
            obj.barcode = message.barcode;
        }
        if (message.fee !== undefined) {
            obj.fee = amount_1.Amount.toJSON(message.fee);
        }
        return obj;
    },
    create(base) {
        return exports.CashDeposit.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCashDeposit();
        message.merchant = (object.merchant !== undefined && object.merchant !== null)
            ? exports.Merchant.fromPartial(object.merchant)
            : undefined;
        message.errorCode = object.errorCode ?? transaction_error_code_1.TransactionErrorCode.INVALID_ERROR_CODE;
        message.cashDepositDescriptor =
            (object.cashDepositDescriptor !== undefined && object.cashDepositDescriptor !== null)
                ? payment_cash_deposit_1.CashDepositDescriptor.fromPartial(object.cashDepositDescriptor)
                : undefined;
        message.barcode = object.barcode ?? '';
        message.fee = (object.fee !== undefined && object.fee !== null)
            ? amount_1.Amount.fromPartial(object.fee)
            : undefined;
        return message;
    },
};
function createBaseCheckDeposit() {
    return {
        frontImageId: '',
        backImageId: '',
        errorCode: transaction_error_code_1.TransactionErrorCode.INVALID_ERROR_CODE,
        reason: check_return_reason_1.CheckReturnReason.INVALID_RETURN_REASON,
        estFundsAvailDateMs: undefined,
    };
}
exports.CheckDeposit = {
    fromJSON(object) {
        const message = {
            frontImageId: isSet(object.frontImageId) ? globalThis.String(object.frontImageId) : '',
            backImageId: isSet(object.backImageId) ? globalThis.String(object.backImageId) : '',
        };
        if (isSet(object.errorCode)) {
            message.errorCode = (0, transaction_error_code_1.transactionErrorCodeFromJSON)(object.errorCode);
        }
        if (isSet(object.reason)) {
            message.reason = (0, check_return_reason_1.checkReturnReasonFromJSON)(object.reason);
        }
        if (isSet(object.estFundsAvailDateMs)) {
            message.estFundsAvailDateMs = globalThis.String(object.estFundsAvailDateMs);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.frontImageId !== '') {
            obj.frontImageId = message.frontImageId;
        }
        if (message.backImageId !== '') {
            obj.backImageId = message.backImageId;
        }
        if (message.errorCode !== undefined &&
            message.errorCode !== transaction_error_code_1.TransactionErrorCode.INVALID_ERROR_CODE) {
            obj.errorCode = (0, transaction_error_code_1.transactionErrorCodeToJSON)(message.errorCode);
        }
        if (message.reason !== undefined && message.reason !== check_return_reason_1.CheckReturnReason.INVALID_RETURN_REASON) {
            obj.reason = (0, check_return_reason_1.checkReturnReasonToJSON)(message.reason);
        }
        if (message.estFundsAvailDateMs !== undefined) {
            obj.estFundsAvailDateMs = message.estFundsAvailDateMs;
        }
        return obj;
    },
    create(base) {
        return exports.CheckDeposit.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCheckDeposit();
        message.frontImageId = object.frontImageId ?? '';
        message.backImageId = object.backImageId ?? '';
        message.errorCode = object.errorCode ?? transaction_error_code_1.TransactionErrorCode.INVALID_ERROR_CODE;
        message.reason = object.reason ?? check_return_reason_1.CheckReturnReason.INVALID_RETURN_REASON;
        message.estFundsAvailDateMs = object.estFundsAvailDateMs ?? undefined;
        return message;
    },
};
function createBaseCheckDepositReturn() {
    return { frontImageId: '', backImageId: '', reason: check_return_reason_1.CheckReturnReason.INVALID_RETURN_REASON };
}
exports.CheckDepositReturn = {
    fromJSON(object) {
        const message = {
            frontImageId: isSet(object.frontImageId) ? globalThis.String(object.frontImageId) : '',
            backImageId: isSet(object.backImageId) ? globalThis.String(object.backImageId) : '',
        };
        if (isSet(object.reason)) {
            message.reason = (0, check_return_reason_1.checkReturnReasonFromJSON)(object.reason);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.frontImageId !== '') {
            obj.frontImageId = message.frontImageId;
        }
        if (message.backImageId !== '') {
            obj.backImageId = message.backImageId;
        }
        if (message.reason !== undefined && message.reason !== check_return_reason_1.CheckReturnReason.INVALID_RETURN_REASON) {
            obj.reason = (0, check_return_reason_1.checkReturnReasonToJSON)(message.reason);
        }
        return obj;
    },
    create(base) {
        return exports.CheckDepositReturn.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCheckDepositReturn();
        message.frontImageId = object.frontImageId ?? '';
        message.backImageId = object.backImageId ?? '';
        message.reason = object.reason ?? check_return_reason_1.CheckReturnReason.INVALID_RETURN_REASON;
        return message;
    },
};
function createBaseFunding() {
    return { details: undefined, isAutoReload: false };
}
exports.Funding = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.details)) {
            message.details = exports.FundingDetails.fromJSON(object.details);
        }
        if (isSet(object.isAutoReload)) {
            message.isAutoReload = globalThis.Boolean(object.isAutoReload);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.details !== undefined) {
            obj.details = exports.FundingDetails.toJSON(message.details);
        }
        if (message.isAutoReload !== undefined && message.isAutoReload !== false) {
            obj.isAutoReload = message.isAutoReload;
        }
        return obj;
    },
    create(base) {
        return exports.Funding.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFunding();
        message.details = (object.details !== undefined && object.details !== null)
            ? exports.FundingDetails.fromPartial(object.details)
            : undefined;
        message.isAutoReload = object.isAutoReload ?? false;
        return message;
    },
};
function createBaseFundingDispute() {
    return { details: undefined };
}
exports.FundingDispute = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.details)) {
            message.details = exports.FundingDetails.fromJSON(object.details);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.details !== undefined) {
            obj.details = exports.FundingDetails.toJSON(message.details);
        }
        return obj;
    },
    create(base) {
        return exports.FundingDispute.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFundingDispute();
        message.details = (object.details !== undefined && object.details !== null)
            ? exports.FundingDetails.fromPartial(object.details)
            : undefined;
        return message;
    },
};
function createBaseFundingDisputeReversal() {
    return { details: undefined };
}
exports.FundingDisputeReversal = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.details)) {
            message.details = exports.FundingDetails.fromJSON(object.details);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.details !== undefined) {
            obj.details = exports.FundingDetails.toJSON(message.details);
        }
        return obj;
    },
    create(base) {
        return exports.FundingDisputeReversal.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFundingDisputeReversal();
        message.details = (object.details !== undefined && object.details !== null)
            ? exports.FundingDetails.fromPartial(object.details)
            : undefined;
        return message;
    },
};
function createBaseFundingFee() {
    return {};
}
exports.FundingFee = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.FundingFee.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseFundingFee();
        return message;
    },
};
function createBaseFundingFeeReversal() {
    return {};
}
exports.FundingFeeReversal = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.FundingFeeReversal.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseFundingFeeReversal();
        return message;
    },
};
function createBaseFundingReversal() {
    return { details: undefined };
}
exports.FundingReversal = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.details)) {
            message.details = exports.FundingDetails.fromJSON(object.details);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.details !== undefined) {
            obj.details = exports.FundingDetails.toJSON(message.details);
        }
        return obj;
    },
    create(base) {
        return exports.FundingReversal.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFundingReversal();
        message.details = (object.details !== undefined && object.details !== null)
            ? exports.FundingDetails.fromPartial(object.details)
            : undefined;
        return message;
    },
};
function createBaseInstallmentLoanFunding() {
    return {
        accountId: '',
        loanName: '',
        loanType: payment_installment_loan_1.InstallmentLoanType.INVALID_INSTALLMENT_LOAN_TYPE,
    };
}
exports.InstallmentLoanFunding = {
    fromJSON(object) {
        const message = {
            accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : '',
            loanName: isSet(object.loanName) ? globalThis.String(object.loanName) : '',
        };
        if (isSet(object.loanType)) {
            message.loanType = (0, payment_installment_loan_1.installmentLoanTypeFromJSON)(object.loanType);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.accountId !== '') {
            obj.accountId = message.accountId;
        }
        if (message.loanName !== '') {
            obj.loanName = message.loanName;
        }
        if (message.loanType !== undefined &&
            message.loanType !== payment_installment_loan_1.InstallmentLoanType.INVALID_INSTALLMENT_LOAN_TYPE) {
            obj.loanType = (0, payment_installment_loan_1.installmentLoanTypeToJSON)(message.loanType);
        }
        return obj;
    },
    create(base) {
        return exports.InstallmentLoanFunding.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseInstallmentLoanFunding();
        message.accountId = object.accountId ?? '';
        message.loanName = object.loanName ?? '';
        message.loanType = object.loanType ?? payment_installment_loan_1.InstallmentLoanType.INVALID_INSTALLMENT_LOAN_TYPE;
        return message;
    },
};
function createBaseInstallmentLoanPayment() {
    return {
        accountId: '',
        loanAccountId: '',
        loanName: '',
        installmentsCount: 0,
        payments: [],
        manualPayment: false,
        loanType: payment_installment_loan_1.InstallmentLoanType.INVALID_INSTALLMENT_LOAN_TYPE,
        installmentIndex: 0,
        principal: undefined,
        fee: undefined,
    };
}
exports.InstallmentLoanPayment = {
    fromJSON(object) {
        const message = {
            installmentsCount: isSet(object.installmentsCount)
                ? globalThis.Number(object.installmentsCount)
                : 0,
            manualPayment: isSet(object.manualPayment) ? globalThis.Boolean(object.manualPayment) : false,
            installmentIndex: isSet(object.installmentIndex)
                ? globalThis.Number(object.installmentIndex)
                : 0,
        };
        if (isSet(object.accountId)) {
            message.accountId = globalThis.String(object.accountId);
        }
        if (isSet(object.loanAccountId)) {
            message.loanAccountId = globalThis.String(object.loanAccountId);
        }
        if (isSet(object.loanName)) {
            message.loanName = globalThis.String(object.loanName);
        }
        if (globalThis.Array.isArray(object?.payments)) {
            message.payments = object.payments.map((e) => exports.InstallmentLoanPaymentInstallmentPayment.fromJSON(e));
        }
        if (isSet(object.loanType)) {
            message.loanType = (0, payment_installment_loan_1.installmentLoanTypeFromJSON)(object.loanType);
        }
        if (isSet(object.principal)) {
            message.principal = amount_1.Amount.fromJSON(object.principal);
        }
        if (isSet(object.fee)) {
            message.fee = amount_1.Amount.fromJSON(object.fee);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.accountId !== undefined && message.accountId !== '') {
            obj.accountId = message.accountId;
        }
        if (message.loanAccountId !== undefined && message.loanAccountId !== '') {
            obj.loanAccountId = message.loanAccountId;
        }
        if (message.loanName !== undefined && message.loanName !== '') {
            obj.loanName = message.loanName;
        }
        if (message.installmentsCount !== 0) {
            obj.installmentsCount = Math.round(message.installmentsCount);
        }
        if (message.payments?.length) {
            obj.payments = message.payments.map((e) => exports.InstallmentLoanPaymentInstallmentPayment.toJSON(e));
        }
        if (message.manualPayment !== false) {
            obj.manualPayment = message.manualPayment;
        }
        if (message.loanType !== undefined &&
            message.loanType !== payment_installment_loan_1.InstallmentLoanType.INVALID_INSTALLMENT_LOAN_TYPE) {
            obj.loanType = (0, payment_installment_loan_1.installmentLoanTypeToJSON)(message.loanType);
        }
        if (message.installmentIndex !== 0) {
            obj.installmentIndex = Math.round(message.installmentIndex);
        }
        if (message.principal !== undefined) {
            obj.principal = amount_1.Amount.toJSON(message.principal);
        }
        if (message.fee !== undefined) {
            obj.fee = amount_1.Amount.toJSON(message.fee);
        }
        return obj;
    },
    create(base) {
        return exports.InstallmentLoanPayment.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseInstallmentLoanPayment();
        message.accountId = object.accountId ?? '';
        message.loanAccountId = object.loanAccountId ?? '';
        message.loanName = object.loanName ?? '';
        message.installmentsCount = object.installmentsCount ?? 0;
        message.payments =
            object.payments?.map((e) => exports.InstallmentLoanPaymentInstallmentPayment.fromPartial(e)) || [];
        message.manualPayment = object.manualPayment ?? false;
        message.loanType = object.loanType ?? payment_installment_loan_1.InstallmentLoanType.INVALID_INSTALLMENT_LOAN_TYPE;
        message.installmentIndex = object.installmentIndex ?? 0;
        message.principal = (object.principal !== undefined && object.principal !== null)
            ? amount_1.Amount.fromPartial(object.principal)
            : undefined;
        message.fee = (object.fee !== undefined && object.fee !== null)
            ? amount_1.Amount.fromPartial(object.fee)
            : undefined;
        return message;
    },
};
function createBaseInstallmentLoanPaymentInstallmentPayment() {
    return {
        installmentId: '',
        principal: amount_1.Amount.fromPartial({}),
        fee: amount_1.Amount.fromPartial({}),
        index: 0,
    };
}
exports.InstallmentLoanPaymentInstallmentPayment = {
    fromJSON(object) {
        const message = {
            principal: isSet(object.principal)
                ? amount_1.Amount.fromJSON(object.principal)
                : amount_1.Amount.fromPartial({}),
            fee: isSet(object.fee) ? amount_1.Amount.fromJSON(object.fee) : amount_1.Amount.fromPartial({}),
            index: isSet(object.index) ? globalThis.Number(object.index) : 0,
        };
        if (isSet(object.installmentId)) {
            message.installmentId = globalThis.String(object.installmentId);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.installmentId !== undefined && message.installmentId !== '') {
            obj.installmentId = message.installmentId;
        }
        if (message.principal !== undefined) {
            obj.principal = amount_1.Amount.toJSON(message.principal);
        }
        if (message.fee !== undefined) {
            obj.fee = amount_1.Amount.toJSON(message.fee);
        }
        if (message.index !== 0) {
            obj.index = Math.round(message.index);
        }
        return obj;
    },
    create(base) {
        return exports.InstallmentLoanPaymentInstallmentPayment.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseInstallmentLoanPaymentInstallmentPayment();
        message.installmentId = object.installmentId ?? '';
        message.principal = (object.principal !== undefined && object.principal !== null)
            ? amount_1.Amount.fromPartial(object.principal)
            : amount_1.Amount.fromPartial({});
        message.fee = (object.fee !== undefined && object.fee !== null)
            ? amount_1.Amount.fromPartial(object.fee)
            : amount_1.Amount.fromPartial({});
        message.index = object.index ?? 0;
        return message;
    },
};
function createBaseInstallmentLoanBalanceTransfer() {
    return { loans: [] };
}
exports.InstallmentLoanBalanceTransfer = {
    fromJSON(object) {
        const message = {
            loans: globalThis.Array.isArray(object?.loans)
                ? object.loans.map((e) => activity_common_1.CompletedLoan.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.loans?.length) {
            obj.loans = message.loans.map((e) => activity_common_1.CompletedLoan.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.InstallmentLoanBalanceTransfer.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseInstallmentLoanBalanceTransfer();
        message.loans = object.loans?.map((e) => activity_common_1.CompletedLoan.fromPartial(e)) || [];
        return message;
    },
};
function createBaseP2P() {
    return {
        from: undefined,
        to: undefined,
        funding: undefined,
        achOutCredit: undefined,
        requestId: '',
        requestStatus: transfer_request_status_1.TransferRequestStatus.INVALID_REQUEST_STATUS,
        isScheduled: false,
    };
}
exports.P2P = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.from)) {
            message.from = payment_p2p_1.P2PPaymentContextParty.fromJSON(object.from);
        }
        if (isSet(object.to)) {
            message.to = payment_p2p_1.P2PPaymentContextParty.fromJSON(object.to);
        }
        if (isSet(object.funding)) {
            message.funding = exports.Funding.fromJSON(object.funding);
        }
        if (isSet(object.achOutCredit)) {
            message.achOutCredit = exports.AchOutCredit.fromJSON(object.achOutCredit);
        }
        if (isSet(object.requestId)) {
            message.requestId = globalThis.String(object.requestId);
        }
        if (isSet(object.requestStatus)) {
            message.requestStatus = (0, transfer_request_status_1.transferRequestStatusFromJSON)(object.requestStatus);
        }
        if (isSet(object.isScheduled)) {
            message.isScheduled = globalThis.Boolean(object.isScheduled);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.from !== undefined) {
            obj.from = payment_p2p_1.P2PPaymentContextParty.toJSON(message.from);
        }
        if (message.to !== undefined) {
            obj.to = payment_p2p_1.P2PPaymentContextParty.toJSON(message.to);
        }
        if (message.funding !== undefined) {
            obj.funding = exports.Funding.toJSON(message.funding);
        }
        if (message.achOutCredit !== undefined) {
            obj.achOutCredit = exports.AchOutCredit.toJSON(message.achOutCredit);
        }
        if (message.requestId !== undefined && message.requestId !== '') {
            obj.requestId = message.requestId;
        }
        if (message.requestStatus !== undefined &&
            message.requestStatus !== transfer_request_status_1.TransferRequestStatus.INVALID_REQUEST_STATUS) {
            obj.requestStatus = (0, transfer_request_status_1.transferRequestStatusToJSON)(message.requestStatus);
        }
        if (message.isScheduled !== undefined && message.isScheduled !== false) {
            obj.isScheduled = message.isScheduled;
        }
        return obj;
    },
    create(base) {
        return exports.P2P.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseP2P();
        message.from = (object.from !== undefined && object.from !== null)
            ? payment_p2p_1.P2PPaymentContextParty.fromPartial(object.from)
            : undefined;
        message.to = (object.to !== undefined && object.to !== null)
            ? payment_p2p_1.P2PPaymentContextParty.fromPartial(object.to)
            : undefined;
        message.funding = (object.funding !== undefined && object.funding !== null)
            ? exports.Funding.fromPartial(object.funding)
            : undefined;
        message.achOutCredit = (object.achOutCredit !== undefined && object.achOutCredit !== null)
            ? exports.AchOutCredit.fromPartial(object.achOutCredit)
            : undefined;
        message.requestId = object.requestId ?? '';
        message.requestStatus = object.requestStatus ?? transfer_request_status_1.TransferRequestStatus.INVALID_REQUEST_STATUS;
        message.isScheduled = object.isScheduled ?? false;
        return message;
    },
};
function createBaseP2PReversal() {
    return { from: undefined, to: undefined, isScheduled: false };
}
exports.P2PReversal = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.from)) {
            message.from = payment_p2p_1.P2PPaymentContextParty.fromJSON(object.from);
        }
        if (isSet(object.to)) {
            message.to = payment_p2p_1.P2PPaymentContextParty.fromJSON(object.to);
        }
        if (isSet(object.isScheduled)) {
            message.isScheduled = globalThis.Boolean(object.isScheduled);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.from !== undefined) {
            obj.from = payment_p2p_1.P2PPaymentContextParty.toJSON(message.from);
        }
        if (message.to !== undefined) {
            obj.to = payment_p2p_1.P2PPaymentContextParty.toJSON(message.to);
        }
        if (message.isScheduled !== undefined && message.isScheduled !== false) {
            obj.isScheduled = message.isScheduled;
        }
        return obj;
    },
    create(base) {
        return exports.P2PReversal.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseP2PReversal();
        message.from = (object.from !== undefined && object.from !== null)
            ? payment_p2p_1.P2PPaymentContextParty.fromPartial(object.from)
            : undefined;
        message.to = (object.to !== undefined && object.to !== null)
            ? payment_p2p_1.P2PPaymentContextParty.fromPartial(object.to)
            : undefined;
        message.isScheduled = object.isScheduled ?? false;
        return message;
    },
};
function createBaseOfferReward() {
    return { offer: undefined, isOneTimeReward: false };
}
exports.OfferReward = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.offer)) {
            message.offer = offer_1.Offer.fromJSON(object.offer);
        }
        if (isSet(object.isOneTimeReward)) {
            message.isOneTimeReward = globalThis.Boolean(object.isOneTimeReward);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.offer !== undefined) {
            obj.offer = offer_1.Offer.toJSON(message.offer);
        }
        if (message.isOneTimeReward !== undefined && message.isOneTimeReward !== false) {
            obj.isOneTimeReward = message.isOneTimeReward;
        }
        return obj;
    },
    create(base) {
        return exports.OfferReward.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOfferReward();
        message.offer = (object.offer !== undefined && object.offer !== null)
            ? offer_1.Offer.fromPartial(object.offer)
            : undefined;
        message.isOneTimeReward = object.isOneTimeReward ?? false;
        return message;
    },
};
function createBaseReferral() {
    return {
        type: payment_referral_1.RedemptionType.INVALID_REDEMPTION_TYPE,
        userId: '',
        userFullName: '',
        campaign: '',
        title: '',
    };
}
exports.Referral = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.type)) {
            message.type = (0, payment_referral_1.redemptionTypeFromJSON)(object.type);
        }
        if (isSet(object.userId)) {
            message.userId = globalThis.String(object.userId);
        }
        if (isSet(object.userFullName)) {
            message.userFullName = globalThis.String(object.userFullName);
        }
        if (isSet(object.campaign)) {
            message.campaign = globalThis.String(object.campaign);
        }
        if (isSet(object.title)) {
            message.title = globalThis.String(object.title);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.type !== undefined && message.type !== payment_referral_1.RedemptionType.INVALID_REDEMPTION_TYPE) {
            obj.type = (0, payment_referral_1.redemptionTypeToJSON)(message.type);
        }
        if (message.userId !== undefined && message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.userFullName !== undefined && message.userFullName !== '') {
            obj.userFullName = message.userFullName;
        }
        if (message.campaign !== undefined && message.campaign !== '') {
            obj.campaign = message.campaign;
        }
        if (message.title !== undefined && message.title !== '') {
            obj.title = message.title;
        }
        return obj;
    },
    create(base) {
        return exports.Referral.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseReferral();
        message.type = object.type ?? payment_referral_1.RedemptionType.INVALID_REDEMPTION_TYPE;
        message.userId = object.userId ?? '';
        message.userFullName = object.userFullName ?? '';
        message.campaign = object.campaign ?? '';
        message.title = object.title ?? '';
        return message;
    },
};
function createBaseTransfer() {
    return {
        type: payment_transfer_1.TransferType.INVALID_TRANSFER_TYPE,
        counterpartySavingsGoal: undefined,
        roundUpOrigin: undefined,
        reason: payment_transfer_1.TransferReason.INVALID_TRANSFER_REASON,
        description: '',
    };
}
exports.Transfer = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.type)) {
            message.type = (0, payment_transfer_1.transferTypeFromJSON)(object.type);
        }
        if (isSet(object.counterpartySavingsGoal)) {
            message.counterpartySavingsGoal = savings_goal_1.SavingsGoal.fromJSON(object.counterpartySavingsGoal);
        }
        if (isSet(object.roundUpOrigin)) {
            message.roundUpOrigin = exports.TransferRoundUpOrigin.fromJSON(object.roundUpOrigin);
        }
        if (isSet(object.reason)) {
            message.reason = (0, payment_transfer_1.transferReasonFromJSON)(object.reason);
        }
        if (isSet(object.description)) {
            message.description = globalThis.String(object.description);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.type !== undefined && message.type !== payment_transfer_1.TransferType.INVALID_TRANSFER_TYPE) {
            obj.type = (0, payment_transfer_1.transferTypeToJSON)(message.type);
        }
        if (message.counterpartySavingsGoal !== undefined) {
            obj.counterpartySavingsGoal = savings_goal_1.SavingsGoal.toJSON(message.counterpartySavingsGoal);
        }
        if (message.roundUpOrigin !== undefined) {
            obj.roundUpOrigin = exports.TransferRoundUpOrigin.toJSON(message.roundUpOrigin);
        }
        if (message.reason !== undefined && message.reason !== payment_transfer_1.TransferReason.INVALID_TRANSFER_REASON) {
            obj.reason = (0, payment_transfer_1.transferReasonToJSON)(message.reason);
        }
        if (message.description !== undefined && message.description !== '') {
            obj.description = message.description;
        }
        return obj;
    },
    create(base) {
        return exports.Transfer.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransfer();
        message.type = object.type ?? payment_transfer_1.TransferType.INVALID_TRANSFER_TYPE;
        message.counterpartySavingsGoal =
            (object.counterpartySavingsGoal !== undefined && object.counterpartySavingsGoal !== null)
                ? savings_goal_1.SavingsGoal.fromPartial(object.counterpartySavingsGoal)
                : undefined;
        message.roundUpOrigin = (object.roundUpOrigin !== undefined && object.roundUpOrigin !== null)
            ? exports.TransferRoundUpOrigin.fromPartial(object.roundUpOrigin)
            : undefined;
        message.reason = object.reason ?? payment_transfer_1.TransferReason.INVALID_TRANSFER_REASON;
        message.description = object.description ?? '';
        return message;
    },
};
function createBaseTransferRoundUpOrigin() {
    return { merchant: undefined, amount: undefined, createdAtMs: '0' };
}
exports.TransferRoundUpOrigin = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.merchant)) {
            message.merchant = exports.Merchant.fromJSON(object.merchant);
        }
        if (isSet(object.amount)) {
            message.amount = amount_1.Amount.fromJSON(object.amount);
        }
        if (isSet(object.createdAtMs)) {
            message.createdAtMs = globalThis.String(object.createdAtMs);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.merchant !== undefined) {
            obj.merchant = exports.Merchant.toJSON(message.merchant);
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.createdAtMs !== undefined && message.createdAtMs !== '0') {
            obj.createdAtMs = message.createdAtMs;
        }
        return obj;
    },
    create(base) {
        return exports.TransferRoundUpOrigin.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseTransferRoundUpOrigin();
        message.merchant = (object.merchant !== undefined && object.merchant !== null)
            ? exports.Merchant.fromPartial(object.merchant)
            : undefined;
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : undefined;
        message.createdAtMs = object.createdAtMs ?? '0';
        return message;
    },
};
function createBaseFeePayment() {
    return { type: fee_type_1.FeeType.INVALID_FEE_TYPE, feeReferenceId: '', context: undefined };
}
exports.FeePayment = {
    fromJSON(object) {
        const message = {
            type: isSet(object.type) ? (0, fee_type_1.feeTypeFromJSON)(object.type) : fee_type_1.FeeType.INVALID_FEE_TYPE,
        };
        if (isSet(object.feeReferenceId)) {
            message.feeReferenceId = globalThis.String(object.feeReferenceId);
        }
        if (isSet(object.context)) {
            message.context = fee_context_1.FeeContext.fromJSON(object.context);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.type !== fee_type_1.FeeType.INVALID_FEE_TYPE) {
            obj.type = (0, fee_type_1.feeTypeToJSON)(message.type);
        }
        if (message.feeReferenceId !== undefined && message.feeReferenceId !== '') {
            obj.feeReferenceId = message.feeReferenceId;
        }
        if (message.context !== undefined) {
            obj.context = fee_context_1.FeeContext.toJSON(message.context);
        }
        return obj;
    },
    create(base) {
        return exports.FeePayment.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFeePayment();
        message.type = object.type ?? fee_type_1.FeeType.INVALID_FEE_TYPE;
        message.feeReferenceId = object.feeReferenceId ?? '';
        message.context = (object.context !== undefined && object.context !== null)
            ? fee_context_1.FeeContext.fromPartial(object.context)
            : undefined;
        return message;
    },
};
function createBaseRewardOrigin() {
    return {
        amount: undefined,
        merchant: exports.Merchant.fromPartial({}),
        rewardTotal: amount_1.Amount.fromPartial({}),
        offer: offer_1.Offer.fromPartial({}),
        createdAtMs: '0',
    };
}
exports.RewardOrigin = {
    fromJSON(object) {
        const message = {
            merchant: isSet(object.merchant)
                ? exports.Merchant.fromJSON(object.merchant)
                : exports.Merchant.fromPartial({}),
            rewardTotal: isSet(object.rewardTotal)
                ? amount_1.Amount.fromJSON(object.rewardTotal)
                : amount_1.Amount.fromPartial({}),
            offer: isSet(object.offer) ? offer_1.Offer.fromJSON(object.offer) : offer_1.Offer.fromPartial({}),
            createdAtMs: isSet(object.createdAtMs) ? globalThis.String(object.createdAtMs) : '0',
        };
        if (isSet(object.amount)) {
            message.amount = amount_1.Amount.fromJSON(object.amount);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.merchant !== undefined) {
            obj.merchant = exports.Merchant.toJSON(message.merchant);
        }
        if (message.rewardTotal !== undefined) {
            obj.rewardTotal = amount_1.Amount.toJSON(message.rewardTotal);
        }
        if (message.offer !== undefined) {
            obj.offer = offer_1.Offer.toJSON(message.offer);
        }
        if (message.createdAtMs !== '0') {
            obj.createdAtMs = message.createdAtMs;
        }
        return obj;
    },
    create(base) {
        return exports.RewardOrigin.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRewardOrigin();
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : undefined;
        message.merchant = (object.merchant !== undefined && object.merchant !== null)
            ? exports.Merchant.fromPartial(object.merchant)
            : exports.Merchant.fromPartial({});
        message.rewardTotal = (object.rewardTotal !== undefined && object.rewardTotal !== null)
            ? amount_1.Amount.fromPartial(object.rewardTotal)
            : amount_1.Amount.fromPartial({});
        message.offer = (object.offer !== undefined && object.offer !== null)
            ? offer_1.Offer.fromPartial(object.offer)
            : offer_1.Offer.fromPartial({});
        message.createdAtMs = object.createdAtMs ?? '0';
        return message;
    },
};
function createBaseCardPayout() {
    return { card: exports.CardPayoutDetails.fromPartial({}), fee: undefined };
}
exports.CardPayout = {
    fromJSON(object) {
        const message = {
            card: isSet(object.card)
                ? exports.CardPayoutDetails.fromJSON(object.card)
                : exports.CardPayoutDetails.fromPartial({}),
        };
        if (isSet(object.fee)) {
            message.fee = amount_1.Amount.fromJSON(object.fee);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.card !== undefined) {
            obj.card = exports.CardPayoutDetails.toJSON(message.card);
        }
        if (message.fee !== undefined) {
            obj.fee = amount_1.Amount.toJSON(message.fee);
        }
        return obj;
    },
    create(base) {
        return exports.CardPayout.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCardPayout();
        message.card = (object.card !== undefined && object.card !== null)
            ? exports.CardPayoutDetails.fromPartial(object.card)
            : exports.CardPayoutDetails.fromPartial({});
        message.fee = (object.fee !== undefined && object.fee !== null)
            ? amount_1.Amount.fromPartial(object.fee)
            : undefined;
        return message;
    },
};
function createBaseCardPayoutReversal() {
    return { card: exports.CardPayoutDetails.fromPartial({}), fee: undefined };
}
exports.CardPayoutReversal = {
    fromJSON(object) {
        const message = {
            card: isSet(object.card)
                ? exports.CardPayoutDetails.fromJSON(object.card)
                : exports.CardPayoutDetails.fromPartial({}),
        };
        if (isSet(object.fee)) {
            message.fee = amount_1.Amount.fromJSON(object.fee);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.card !== undefined) {
            obj.card = exports.CardPayoutDetails.toJSON(message.card);
        }
        if (message.fee !== undefined) {
            obj.fee = amount_1.Amount.toJSON(message.fee);
        }
        return obj;
    },
    create(base) {
        return exports.CardPayoutReversal.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCardPayoutReversal();
        message.card = (object.card !== undefined && object.card !== null)
            ? exports.CardPayoutDetails.fromPartial(object.card)
            : exports.CardPayoutDetails.fromPartial({});
        message.fee = (object.fee !== undefined && object.fee !== null)
            ? amount_1.Amount.fromPartial(object.fee)
            : undefined;
        return message;
    },
};
function createBaseCardPayoutFee() {
    return {};
}
exports.CardPayoutFee = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.CardPayoutFee.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseCardPayoutFee();
        return message;
    },
};
function createBaseCardPayoutFeeReversal() {
    return {};
}
exports.CardPayoutFeeReversal = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.CardPayoutFeeReversal.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseCardPayoutFeeReversal();
        return message;
    },
};
function createBaseCryptoTrade() {
    return {
        price: amount_1.Amount.fromPartial({}),
        total: amount_1.Amount.fromPartial({}),
        offer: undefined,
        spread: undefined,
        rewardOrigin: undefined,
        roundUp: undefined,
        createdByAdmin: false,
    };
}
exports.CryptoTrade = {
    fromJSON(object) {
        const message = {
            price: isSet(object.price) ? amount_1.Amount.fromJSON(object.price) : amount_1.Amount.fromPartial({}),
            total: isSet(object.total) ? amount_1.Amount.fromJSON(object.total) : amount_1.Amount.fromPartial({}),
        };
        if (isSet(object.offer)) {
            message.offer = offer_1.Offer.fromJSON(object.offer);
        }
        if (isSet(object.spread)) {
            message.spread = amount_1.Amount.fromJSON(object.spread);
        }
        if (isSet(object.rewardOrigin)) {
            message.rewardOrigin = exports.RewardOrigin.fromJSON(object.rewardOrigin);
        }
        if (isSet(object.roundUp)) {
            message.roundUp = globalThis.Boolean(object.roundUp);
        }
        if (isSet(object.createdByAdmin)) {
            message.createdByAdmin = globalThis.Boolean(object.createdByAdmin);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.price !== undefined) {
            obj.price = amount_1.Amount.toJSON(message.price);
        }
        if (message.total !== undefined) {
            obj.total = amount_1.Amount.toJSON(message.total);
        }
        if (message.offer !== undefined) {
            obj.offer = offer_1.Offer.toJSON(message.offer);
        }
        if (message.spread !== undefined) {
            obj.spread = amount_1.Amount.toJSON(message.spread);
        }
        if (message.rewardOrigin !== undefined) {
            obj.rewardOrigin = exports.RewardOrigin.toJSON(message.rewardOrigin);
        }
        if (message.roundUp !== undefined) {
            obj.roundUp = message.roundUp;
        }
        if (message.createdByAdmin !== undefined && message.createdByAdmin !== false) {
            obj.createdByAdmin = message.createdByAdmin;
        }
        return obj;
    },
    create(base) {
        return exports.CryptoTrade.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCryptoTrade();
        message.price = (object.price !== undefined && object.price !== null)
            ? amount_1.Amount.fromPartial(object.price)
            : amount_1.Amount.fromPartial({});
        message.total = (object.total !== undefined && object.total !== null)
            ? amount_1.Amount.fromPartial(object.total)
            : amount_1.Amount.fromPartial({});
        message.offer = (object.offer !== undefined && object.offer !== null)
            ? offer_1.Offer.fromPartial(object.offer)
            : undefined;
        message.spread = (object.spread !== undefined && object.spread !== null)
            ? amount_1.Amount.fromPartial(object.spread)
            : undefined;
        message.rewardOrigin = (object.rewardOrigin !== undefined && object.rewardOrigin !== null)
            ? exports.RewardOrigin.fromPartial(object.rewardOrigin)
            : undefined;
        message.roundUp = object.roundUp ?? undefined;
        message.createdByAdmin = object.createdByAdmin ?? false;
        return message;
    },
};
function createBaseCryptoTradeTransfer() {
    return {
        price: amount_1.Amount.fromPartial({}),
        amount: amount_1.Amount.fromPartial({}),
        rewardTotal: undefined,
        spread: undefined,
        rewardOrigin: undefined,
        createdByAdmin: false,
    };
}
exports.CryptoTradeTransfer = {
    fromJSON(object) {
        const message = {
            price: isSet(object.price) ? amount_1.Amount.fromJSON(object.price) : amount_1.Amount.fromPartial({}),
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
        };
        if (isSet(object.rewardTotal)) {
            message.rewardTotal = amount_1.Amount.fromJSON(object.rewardTotal);
        }
        if (isSet(object.spread)) {
            message.spread = amount_1.Amount.fromJSON(object.spread);
        }
        if (isSet(object.rewardOrigin)) {
            message.rewardOrigin = exports.RewardOrigin.fromJSON(object.rewardOrigin);
        }
        if (isSet(object.createdByAdmin)) {
            message.createdByAdmin = globalThis.Boolean(object.createdByAdmin);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.price !== undefined) {
            obj.price = amount_1.Amount.toJSON(message.price);
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.rewardTotal !== undefined) {
            obj.rewardTotal = amount_1.Amount.toJSON(message.rewardTotal);
        }
        if (message.spread !== undefined) {
            obj.spread = amount_1.Amount.toJSON(message.spread);
        }
        if (message.rewardOrigin !== undefined) {
            obj.rewardOrigin = exports.RewardOrigin.toJSON(message.rewardOrigin);
        }
        if (message.createdByAdmin !== undefined && message.createdByAdmin !== false) {
            obj.createdByAdmin = message.createdByAdmin;
        }
        return obj;
    },
    create(base) {
        return exports.CryptoTradeTransfer.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCryptoTradeTransfer();
        message.price = (object.price !== undefined && object.price !== null)
            ? amount_1.Amount.fromPartial(object.price)
            : amount_1.Amount.fromPartial({});
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        message.rewardTotal = (object.rewardTotal !== undefined && object.rewardTotal !== null)
            ? amount_1.Amount.fromPartial(object.rewardTotal)
            : undefined;
        message.spread = (object.spread !== undefined && object.spread !== null)
            ? amount_1.Amount.fromPartial(object.spread)
            : undefined;
        message.rewardOrigin = (object.rewardOrigin !== undefined && object.rewardOrigin !== null)
            ? exports.RewardOrigin.fromPartial(object.rewardOrigin)
            : undefined;
        message.createdByAdmin = object.createdByAdmin ?? false;
        return message;
    },
};
function createBaseStockTrade() {
    return {
        instrument: exports.Instrument.fromPartial({}),
        fillQuantity: '',
        fillPrice: amount_1.Amount.fromPartial({}),
        isAdjustment: false,
        purchase: undefined,
        sale: undefined,
    };
}
exports.StockTrade = {
    fromJSON(object) {
        const message = {
            instrument: isSet(object.instrument)
                ? exports.Instrument.fromJSON(object.instrument)
                : exports.Instrument.fromPartial({}),
            fillQuantity: isSet(object.fillQuantity) ? globalThis.String(object.fillQuantity) : '',
            fillPrice: isSet(object.fillPrice)
                ? amount_1.Amount.fromJSON(object.fillPrice)
                : amount_1.Amount.fromPartial({}),
            isAdjustment: isSet(object.isAdjustment) ? globalThis.Boolean(object.isAdjustment) : false,
        };
        if (isSet(object.purchase)) {
            message.purchase = exports.StockTradePurchase.fromJSON(object.purchase);
        }
        if (isSet(object.sale)) {
            message.sale = exports.StockTradeSale.fromJSON(object.sale);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.instrument !== undefined) {
            obj.instrument = exports.Instrument.toJSON(message.instrument);
        }
        if (message.fillQuantity !== '') {
            obj.fillQuantity = message.fillQuantity;
        }
        if (message.fillPrice !== undefined) {
            obj.fillPrice = amount_1.Amount.toJSON(message.fillPrice);
        }
        if (message.isAdjustment !== false) {
            obj.isAdjustment = message.isAdjustment;
        }
        if (message.purchase !== undefined) {
            obj.purchase = exports.StockTradePurchase.toJSON(message.purchase);
        }
        if (message.sale !== undefined) {
            obj.sale = exports.StockTradeSale.toJSON(message.sale);
        }
        return obj;
    },
    create(base) {
        return exports.StockTrade.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseStockTrade();
        message.instrument = (object.instrument !== undefined && object.instrument !== null)
            ? exports.Instrument.fromPartial(object.instrument)
            : exports.Instrument.fromPartial({});
        message.fillQuantity = object.fillQuantity ?? '';
        message.fillPrice = (object.fillPrice !== undefined && object.fillPrice !== null)
            ? amount_1.Amount.fromPartial(object.fillPrice)
            : amount_1.Amount.fromPartial({});
        message.isAdjustment = object.isAdjustment ?? false;
        message.purchase = (object.purchase !== undefined && object.purchase !== null)
            ? exports.StockTradePurchase.fromPartial(object.purchase)
            : undefined;
        message.sale = (object.sale !== undefined && object.sale !== null)
            ? exports.StockTradeSale.fromPartial(object.sale)
            : undefined;
        return message;
    },
};
function createBaseStockTradePurchase() {
    return { isRoundUp: false };
}
exports.StockTradePurchase = {
    fromJSON(object) {
        const message = {
            isRoundUp: isSet(object.isRoundUp) ? globalThis.Boolean(object.isRoundUp) : false,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.isRoundUp !== false) {
            obj.isRoundUp = message.isRoundUp;
        }
        return obj;
    },
    create(base) {
        return exports.StockTradePurchase.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseStockTradePurchase();
        message.isRoundUp = object.isRoundUp ?? false;
        return message;
    },
};
function createBaseStockTradeSale() {
    return {};
}
exports.StockTradeSale = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.StockTradeSale.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseStockTradeSale();
        return message;
    },
};
function createBaseStockFees() {
    return { sale: undefined };
}
exports.StockFees = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.sale)) {
            message.sale = exports.StockFeesSale.fromJSON(object.sale);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.sale !== undefined) {
            obj.sale = exports.StockFeesSale.toJSON(message.sale);
        }
        return obj;
    },
    create(base) {
        return exports.StockFees.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseStockFees();
        message.sale = (object.sale !== undefined && object.sale !== null)
            ? exports.StockFeesSale.fromPartial(object.sale)
            : undefined;
        return message;
    },
};
function createBaseStockFeesSale() {
    return { instrument: exports.Instrument.fromPartial({}), fees: exports.StockFeesSaleFees.fromPartial({}) };
}
exports.StockFeesSale = {
    fromJSON(object) {
        const message = {
            instrument: isSet(object.instrument)
                ? exports.Instrument.fromJSON(object.instrument)
                : exports.Instrument.fromPartial({}),
            fees: isSet(object.fees)
                ? exports.StockFeesSaleFees.fromJSON(object.fees)
                : exports.StockFeesSaleFees.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.instrument !== undefined) {
            obj.instrument = exports.Instrument.toJSON(message.instrument);
        }
        if (message.fees !== undefined) {
            obj.fees = exports.StockFeesSaleFees.toJSON(message.fees);
        }
        return obj;
    },
    create(base) {
        return exports.StockFeesSale.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseStockFeesSale();
        message.instrument = (object.instrument !== undefined && object.instrument !== null)
            ? exports.Instrument.fromPartial(object.instrument)
            : exports.Instrument.fromPartial({});
        message.fees = (object.fees !== undefined && object.fees !== null)
            ? exports.StockFeesSaleFees.fromPartial(object.fees)
            : exports.StockFeesSaleFees.fromPartial({});
        return message;
    },
};
function createBaseStockFeesSaleFees() {
    return { secFee: amount_1.Amount.fromPartial({}), tafFee: amount_1.Amount.fromPartial({}) };
}
exports.StockFeesSaleFees = {
    fromJSON(object) {
        const message = {
            secFee: isSet(object.secFee) ? amount_1.Amount.fromJSON(object.secFee) : amount_1.Amount.fromPartial({}),
            tafFee: isSet(object.tafFee) ? amount_1.Amount.fromJSON(object.tafFee) : amount_1.Amount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.secFee !== undefined) {
            obj.secFee = amount_1.Amount.toJSON(message.secFee);
        }
        if (message.tafFee !== undefined) {
            obj.tafFee = amount_1.Amount.toJSON(message.tafFee);
        }
        return obj;
    },
    create(base) {
        return exports.StockFeesSaleFees.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseStockFeesSaleFees();
        message.secFee = (object.secFee !== undefined && object.secFee !== null)
            ? amount_1.Amount.fromPartial(object.secFee)
            : amount_1.Amount.fromPartial({});
        message.tafFee = (object.tafFee !== undefined && object.tafFee !== null)
            ? amount_1.Amount.fromPartial(object.tafFee)
            : amount_1.Amount.fromPartial({});
        return message;
    },
};
function createBaseStockCorporateAction() {
    return {
        instrument: exports.Instrument.fromPartial({}),
        dividend: undefined,
        dividendTax: undefined,
        stockSplit: undefined,
        stockSpinoff: undefined,
        mergerAcquisition: undefined,
    };
}
exports.StockCorporateAction = {
    fromJSON(object) {
        const message = {
            instrument: isSet(object.instrument)
                ? exports.Instrument.fromJSON(object.instrument)
                : exports.Instrument.fromPartial({}),
        };
        if (isSet(object.dividend)) {
            message.dividend = stock_corporate_action_1.Dividend.fromJSON(object.dividend);
        }
        if (isSet(object.dividendTax)) {
            message.dividendTax = stock_corporate_action_1.DividendTax.fromJSON(object.dividendTax);
        }
        if (isSet(object.stockSplit)) {
            message.stockSplit = stock_corporate_action_1.StockSplit.fromJSON(object.stockSplit);
        }
        if (isSet(object.stockSpinoff)) {
            message.stockSpinoff = stock_corporate_action_1.StockSpinoff.fromJSON(object.stockSpinoff);
        }
        if (isSet(object.mergerAcquisition)) {
            message.mergerAcquisition = stock_corporate_action_1.MergerAcquisition.fromJSON(object.mergerAcquisition);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.instrument !== undefined) {
            obj.instrument = exports.Instrument.toJSON(message.instrument);
        }
        if (message.dividend !== undefined) {
            obj.dividend = stock_corporate_action_1.Dividend.toJSON(message.dividend);
        }
        if (message.dividendTax !== undefined) {
            obj.dividendTax = stock_corporate_action_1.DividendTax.toJSON(message.dividendTax);
        }
        if (message.stockSplit !== undefined) {
            obj.stockSplit = stock_corporate_action_1.StockSplit.toJSON(message.stockSplit);
        }
        if (message.stockSpinoff !== undefined) {
            obj.stockSpinoff = stock_corporate_action_1.StockSpinoff.toJSON(message.stockSpinoff);
        }
        if (message.mergerAcquisition !== undefined) {
            obj.mergerAcquisition = stock_corporate_action_1.MergerAcquisition.toJSON(message.mergerAcquisition);
        }
        return obj;
    },
    create(base) {
        return exports.StockCorporateAction.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseStockCorporateAction();
        message.instrument = (object.instrument !== undefined && object.instrument !== null)
            ? exports.Instrument.fromPartial(object.instrument)
            : exports.Instrument.fromPartial({});
        message.dividend = (object.dividend !== undefined && object.dividend !== null)
            ? stock_corporate_action_1.Dividend.fromPartial(object.dividend)
            : undefined;
        message.dividendTax = (object.dividendTax !== undefined && object.dividendTax !== null)
            ? stock_corporate_action_1.DividendTax.fromPartial(object.dividendTax)
            : undefined;
        message.stockSplit = (object.stockSplit !== undefined && object.stockSplit !== null)
            ? stock_corporate_action_1.StockSplit.fromPartial(object.stockSplit)
            : undefined;
        message.stockSpinoff = (object.stockSpinoff !== undefined && object.stockSpinoff !== null)
            ? stock_corporate_action_1.StockSpinoff.fromPartial(object.stockSpinoff)
            : undefined;
        message.mergerAcquisition =
            (object.mergerAcquisition !== undefined && object.mergerAcquisition !== null)
                ? stock_corporate_action_1.MergerAcquisition.fromPartial(object.mergerAcquisition)
                : undefined;
        return message;
    },
};
function createBaseStockTradeTransfer() {
    return {
        symbol: '',
        quantity: '',
        averagePrice: undefined,
        orderStatus: stock_order_1.OrderStatus.INVALID_ORDER_STATUS,
        orderAdjustment: undefined,
        createdByAdmin: false,
        canceledByAdmin: false,
        purchase: undefined,
        sale: undefined,
    };
}
exports.StockTradeTransfer = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.symbol)) {
            message.symbol = globalThis.String(object.symbol);
        }
        if (isSet(object.quantity)) {
            message.quantity = globalThis.String(object.quantity);
        }
        if (isSet(object.averagePrice)) {
            message.averagePrice = amount_1.Amount.fromJSON(object.averagePrice);
        }
        if (isSet(object.orderStatus)) {
            message.orderStatus = (0, stock_order_1.orderStatusFromJSON)(object.orderStatus);
        }
        if (isSet(object.orderAdjustment)) {
            message.orderAdjustment = exports.StockTradeTransferOrderAdjustment.fromJSON(object.orderAdjustment);
        }
        if (isSet(object.createdByAdmin)) {
            message.createdByAdmin = globalThis.Boolean(object.createdByAdmin);
        }
        if (isSet(object.canceledByAdmin)) {
            message.canceledByAdmin = globalThis.Boolean(object.canceledByAdmin);
        }
        if (isSet(object.purchase)) {
            message.purchase = exports.StockTradeTransferPurchase.fromJSON(object.purchase);
        }
        if (isSet(object.sale)) {
            message.sale = exports.StockTradeTransferSale.fromJSON(object.sale);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.symbol !== undefined && message.symbol !== '') {
            obj.symbol = message.symbol;
        }
        if (message.quantity !== undefined && message.quantity !== '') {
            obj.quantity = message.quantity;
        }
        if (message.averagePrice !== undefined) {
            obj.averagePrice = amount_1.Amount.toJSON(message.averagePrice);
        }
        if (message.orderStatus !== undefined && message.orderStatus !== stock_order_1.OrderStatus.INVALID_ORDER_STATUS) {
            obj.orderStatus = (0, stock_order_1.orderStatusToJSON)(message.orderStatus);
        }
        if (message.orderAdjustment !== undefined) {
            obj.orderAdjustment = exports.StockTradeTransferOrderAdjustment.toJSON(message.orderAdjustment);
        }
        if (message.createdByAdmin !== undefined && message.createdByAdmin !== false) {
            obj.createdByAdmin = message.createdByAdmin;
        }
        if (message.canceledByAdmin !== undefined && message.canceledByAdmin !== false) {
            obj.canceledByAdmin = message.canceledByAdmin;
        }
        if (message.purchase !== undefined) {
            obj.purchase = exports.StockTradeTransferPurchase.toJSON(message.purchase);
        }
        if (message.sale !== undefined) {
            obj.sale = exports.StockTradeTransferSale.toJSON(message.sale);
        }
        return obj;
    },
    create(base) {
        return exports.StockTradeTransfer.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseStockTradeTransfer();
        message.symbol = object.symbol ?? '';
        message.quantity = object.quantity ?? '';
        message.averagePrice = (object.averagePrice !== undefined && object.averagePrice !== null)
            ? amount_1.Amount.fromPartial(object.averagePrice)
            : undefined;
        message.orderStatus = object.orderStatus ?? stock_order_1.OrderStatus.INVALID_ORDER_STATUS;
        message.orderAdjustment =
            (object.orderAdjustment !== undefined && object.orderAdjustment !== null)
                ? exports.StockTradeTransferOrderAdjustment.fromPartial(object.orderAdjustment)
                : undefined;
        message.createdByAdmin = object.createdByAdmin ?? false;
        message.canceledByAdmin = object.canceledByAdmin ?? false;
        message.purchase = (object.purchase !== undefined && object.purchase !== null)
            ? exports.StockTradeTransferPurchase.fromPartial(object.purchase)
            : undefined;
        message.sale = (object.sale !== undefined && object.sale !== null)
            ? exports.StockTradeTransferSale.fromPartial(object.sale)
            : undefined;
        return message;
    },
};
function createBaseStockTradeTransferPurchase() {
    return {};
}
exports.StockTradeTransferPurchase = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.StockTradeTransferPurchase.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseStockTradeTransferPurchase();
        return message;
    },
};
function createBaseStockTradeTransferSale() {
    return { fees: amount_1.Amount.fromPartial({}) };
}
exports.StockTradeTransferSale = {
    fromJSON(object) {
        const message = {
            fees: isSet(object.fees) ? amount_1.Amount.fromJSON(object.fees) : amount_1.Amount.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.fees !== undefined) {
            obj.fees = amount_1.Amount.toJSON(message.fees);
        }
        return obj;
    },
    create(base) {
        return exports.StockTradeTransferSale.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseStockTradeTransferSale();
        message.fees = (object.fees !== undefined && object.fees !== null)
            ? amount_1.Amount.fromPartial(object.fees)
            : amount_1.Amount.fromPartial({});
        return message;
    },
};
function createBaseStockTradeTransferOrderAdjustment() {
    return { quantity: '' };
}
exports.StockTradeTransferOrderAdjustment = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.quantity)) {
            message.quantity = globalThis.String(object.quantity);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.quantity !== undefined && message.quantity !== '') {
            obj.quantity = message.quantity;
        }
        return obj;
    },
    create(base) {
        return exports.StockTradeTransferOrderAdjustment.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseStockTradeTransferOrderAdjustment();
        message.quantity = object.quantity ?? '';
        return message;
    },
};
function createBaseStockCorporateActionTransfer() {
    return { symbol: '', description: '' };
}
exports.StockCorporateActionTransfer = {
    fromJSON(object) {
        const message = {
            symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
        };
        if (isSet(object.description)) {
            message.description = globalThis.String(object.description);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.symbol !== '') {
            obj.symbol = message.symbol;
        }
        if (message.description !== undefined && message.description !== '') {
            obj.description = message.description;
        }
        return obj;
    },
    create(base) {
        return exports.StockCorporateActionTransfer.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseStockCorporateActionTransfer();
        message.symbol = object.symbol ?? '';
        message.description = object.description ?? '';
        return message;
    },
};
function createBaseStockGraduationTransfer() {
    return { symbol: '', quantity: '' };
}
exports.StockGraduationTransfer = {
    fromJSON(object) {
        const message = {
            symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
            quantity: isSet(object.quantity) ? globalThis.String(object.quantity) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.symbol !== '') {
            obj.symbol = message.symbol;
        }
        if (message.quantity !== '') {
            obj.quantity = message.quantity;
        }
        return obj;
    },
    create(base) {
        return exports.StockGraduationTransfer.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseStockGraduationTransfer();
        message.symbol = object.symbol ?? '';
        message.quantity = object.quantity ?? '';
        return message;
    },
};
function createBaseStockInterestAdjustment() {
    return { comment: '' };
}
exports.StockInterestAdjustment = {
    fromJSON(object) {
        const message = {
            comment: isSet(object.comment) ? globalThis.String(object.comment) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.comment !== '') {
            obj.comment = message.comment;
        }
        return obj;
    },
    create(base) {
        return exports.StockInterestAdjustment.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseStockInterestAdjustment();
        message.comment = object.comment ?? '';
        return message;
    },
};
function createBaseStockCustomerAccountTransfer() {
    return {};
}
exports.StockCustomerAccountTransfer = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.StockCustomerAccountTransfer.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseStockCustomerAccountTransfer();
        return message;
    },
};
function createBaseAchInParties() {
    return {
        counterpartyCompanyName: '',
        counterpartyCompanyDescription: '',
        stepIndividualName: '',
    };
}
exports.AchInParties = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.counterpartyCompanyName)) {
            message.counterpartyCompanyName = globalThis.String(object.counterpartyCompanyName);
        }
        if (isSet(object.counterpartyCompanyDescription)) {
            message.counterpartyCompanyDescription = globalThis.String(object.counterpartyCompanyDescription);
        }
        if (isSet(object.stepIndividualName)) {
            message.stepIndividualName = globalThis.String(object.stepIndividualName);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.counterpartyCompanyName !== undefined && message.counterpartyCompanyName !== '') {
            obj.counterpartyCompanyName = message.counterpartyCompanyName;
        }
        if (message.counterpartyCompanyDescription !== undefined &&
            message.counterpartyCompanyDescription !== '') {
            obj.counterpartyCompanyDescription = message.counterpartyCompanyDescription;
        }
        if (message.stepIndividualName !== undefined && message.stepIndividualName !== '') {
            obj.stepIndividualName = message.stepIndividualName;
        }
        return obj;
    },
    create(base) {
        return exports.AchInParties.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAchInParties();
        message.counterpartyCompanyName = object.counterpartyCompanyName ?? '';
        message.counterpartyCompanyDescription = object.counterpartyCompanyDescription ?? '';
        message.stepIndividualName = object.stepIndividualName ?? '';
        return message;
    },
};
function createBaseBank() {
    return {
        name: '',
        logoUrl: '',
        maskedAccountNumber: '',
        accountType: ach_account_1.AchAccountType.INVALID_ACH_ACCOUNT_TYPE,
    };
}
exports.Bank = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.name)) {
            message.name = globalThis.String(object.name);
        }
        if (isSet(object.logoUrl)) {
            message.logoUrl = globalThis.String(object.logoUrl);
        }
        if (isSet(object.maskedAccountNumber)) {
            message.maskedAccountNumber = globalThis.String(object.maskedAccountNumber);
        }
        if (isSet(object.accountType)) {
            message.accountType = (0, ach_account_1.achAccountTypeFromJSON)(object.accountType);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.name !== undefined && message.name !== '') {
            obj.name = message.name;
        }
        if (message.logoUrl !== undefined && message.logoUrl !== '') {
            obj.logoUrl = message.logoUrl;
        }
        if (message.maskedAccountNumber !== undefined && message.maskedAccountNumber !== '') {
            obj.maskedAccountNumber = message.maskedAccountNumber;
        }
        if (message.accountType !== undefined &&
            message.accountType !== ach_account_1.AchAccountType.INVALID_ACH_ACCOUNT_TYPE) {
            obj.accountType = (0, ach_account_1.achAccountTypeToJSON)(message.accountType);
        }
        return obj;
    },
    create(base) {
        return exports.Bank.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseBank();
        message.name = object.name ?? '';
        message.logoUrl = object.logoUrl ?? '';
        message.maskedAccountNumber = object.maskedAccountNumber ?? '';
        message.accountType = object.accountType ?? ach_account_1.AchAccountType.INVALID_ACH_ACCOUNT_TYPE;
        return message;
    },
};
function createBaseCardDetails() {
    return {
        type: card_details_1.CardType.INVALID_CARD_TYPE,
        panSuffix: '',
        entryType: payment_card_1.CardEntryType.INVALID_CARD_ENTRY_TYPE,
        walletProvider: wallet_provider_1.WalletProvider.NOT_A_WALLET_PROVIDER,
    };
}
exports.CardDetails = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.type)) {
            message.type = (0, card_details_1.cardTypeFromJSON)(object.type);
        }
        if (isSet(object.panSuffix)) {
            message.panSuffix = globalThis.String(object.panSuffix);
        }
        if (isSet(object.entryType)) {
            message.entryType = (0, payment_card_1.cardEntryTypeFromJSON)(object.entryType);
        }
        if (isSet(object.walletProvider)) {
            message.walletProvider = (0, wallet_provider_1.walletProviderFromJSON)(object.walletProvider);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.type !== undefined && message.type !== card_details_1.CardType.INVALID_CARD_TYPE) {
            obj.type = (0, card_details_1.cardTypeToJSON)(message.type);
        }
        if (message.panSuffix !== undefined && message.panSuffix !== '') {
            obj.panSuffix = message.panSuffix;
        }
        if (message.entryType !== undefined && message.entryType !== payment_card_1.CardEntryType.INVALID_CARD_ENTRY_TYPE) {
            obj.entryType = (0, payment_card_1.cardEntryTypeToJSON)(message.entryType);
        }
        if (message.walletProvider !== undefined &&
            message.walletProvider !== wallet_provider_1.WalletProvider.NOT_A_WALLET_PROVIDER) {
            obj.walletProvider = (0, wallet_provider_1.walletProviderToJSON)(message.walletProvider);
        }
        return obj;
    },
    create(base) {
        return exports.CardDetails.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCardDetails();
        message.type = object.type ?? card_details_1.CardType.INVALID_CARD_TYPE;
        message.panSuffix = object.panSuffix ?? '';
        message.entryType = object.entryType ?? payment_card_1.CardEntryType.INVALID_CARD_ENTRY_TYPE;
        message.walletProvider = object.walletProvider ?? wallet_provider_1.WalletProvider.NOT_A_WALLET_PROVIDER;
        return message;
    },
};
function createBaseFundingDetails() {
    return {
        network: '',
        panSuffix: '',
        cardType: external_card_1.ExternalCardType.INVALID_FUNDING_CARD_TYPE,
        walletProvider: wallet_provider_1.WalletProvider.NOT_A_WALLET_PROVIDER,
        fee: undefined,
    };
}
exports.FundingDetails = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.network)) {
            message.network = globalThis.String(object.network);
        }
        if (isSet(object.panSuffix)) {
            message.panSuffix = globalThis.String(object.panSuffix);
        }
        if (isSet(object.cardType)) {
            message.cardType = (0, external_card_1.externalCardTypeFromJSON)(object.cardType);
        }
        if (isSet(object.walletProvider)) {
            message.walletProvider = (0, wallet_provider_1.walletProviderFromJSON)(object.walletProvider);
        }
        if (isSet(object.fee)) {
            message.fee = amount_1.Amount.fromJSON(object.fee);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.network !== undefined && message.network !== '') {
            obj.network = message.network;
        }
        if (message.panSuffix !== undefined && message.panSuffix !== '') {
            obj.panSuffix = message.panSuffix;
        }
        if (message.cardType !== undefined &&
            message.cardType !== external_card_1.ExternalCardType.INVALID_FUNDING_CARD_TYPE) {
            obj.cardType = (0, external_card_1.externalCardTypeToJSON)(message.cardType);
        }
        if (message.walletProvider !== undefined &&
            message.walletProvider !== wallet_provider_1.WalletProvider.NOT_A_WALLET_PROVIDER) {
            obj.walletProvider = (0, wallet_provider_1.walletProviderToJSON)(message.walletProvider);
        }
        if (message.fee !== undefined) {
            obj.fee = amount_1.Amount.toJSON(message.fee);
        }
        return obj;
    },
    create(base) {
        return exports.FundingDetails.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseFundingDetails();
        message.network = object.network ?? '';
        message.panSuffix = object.panSuffix ?? '';
        message.cardType = object.cardType ?? external_card_1.ExternalCardType.INVALID_FUNDING_CARD_TYPE;
        message.walletProvider = object.walletProvider ?? wallet_provider_1.WalletProvider.NOT_A_WALLET_PROVIDER;
        message.fee = (object.fee !== undefined && object.fee !== null)
            ? amount_1.Amount.fromPartial(object.fee)
            : undefined;
        return message;
    },
};
function createBaseCardPayoutDetails() {
    return { cardType: external_card_1.ExternalCardType.INVALID_FUNDING_CARD_TYPE, network: '', panSuffix: '' };
}
exports.CardPayoutDetails = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.cardType)) {
            message.cardType = (0, external_card_1.externalCardTypeFromJSON)(object.cardType);
        }
        if (isSet(object.network)) {
            message.network = globalThis.String(object.network);
        }
        if (isSet(object.panSuffix)) {
            message.panSuffix = globalThis.String(object.panSuffix);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.cardType !== undefined &&
            message.cardType !== external_card_1.ExternalCardType.INVALID_FUNDING_CARD_TYPE) {
            obj.cardType = (0, external_card_1.externalCardTypeToJSON)(message.cardType);
        }
        if (message.network !== undefined && message.network !== '') {
            obj.network = message.network;
        }
        if (message.panSuffix !== undefined && message.panSuffix !== '') {
            obj.panSuffix = message.panSuffix;
        }
        return obj;
    },
    create(base) {
        return exports.CardPayoutDetails.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCardPayoutDetails();
        message.cardType = object.cardType ?? external_card_1.ExternalCardType.INVALID_FUNDING_CARD_TYPE;
        message.network = object.network ?? '';
        message.panSuffix = object.panSuffix ?? '';
        return message;
    },
};
function createBaseMerchant() {
    return {
        name: '',
        logoUrl: '',
        locationId: '',
        address: '',
        enrichedId: '',
        isBlockable: false,
        mcc: '',
        country: '',
        category: '',
    };
}
exports.Merchant = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.name)) {
            message.name = globalThis.String(object.name);
        }
        if (isSet(object.logoUrl)) {
            message.logoUrl = globalThis.String(object.logoUrl);
        }
        if (isSet(object.locationId)) {
            message.locationId = globalThis.String(object.locationId);
        }
        if (isSet(object.address)) {
            message.address = globalThis.String(object.address);
        }
        if (isSet(object.enrichedId)) {
            message.enrichedId = globalThis.String(object.enrichedId);
        }
        if (isSet(object.isBlockable)) {
            message.isBlockable = globalThis.Boolean(object.isBlockable);
        }
        if (isSet(object.mcc)) {
            message.mcc = globalThis.String(object.mcc);
        }
        if (isSet(object.country)) {
            message.country = globalThis.String(object.country);
        }
        if (isSet(object.category)) {
            message.category = globalThis.String(object.category);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.name !== undefined && message.name !== '') {
            obj.name = message.name;
        }
        if (message.logoUrl !== undefined && message.logoUrl !== '') {
            obj.logoUrl = message.logoUrl;
        }
        if (message.locationId !== undefined && message.locationId !== '') {
            obj.locationId = message.locationId;
        }
        if (message.address !== undefined && message.address !== '') {
            obj.address = message.address;
        }
        if (message.enrichedId !== undefined && message.enrichedId !== '') {
            obj.enrichedId = message.enrichedId;
        }
        if (message.isBlockable !== undefined && message.isBlockable !== false) {
            obj.isBlockable = message.isBlockable;
        }
        if (message.mcc !== undefined && message.mcc !== '') {
            obj.mcc = message.mcc;
        }
        if (message.country !== undefined && message.country !== '') {
            obj.country = message.country;
        }
        if (message.category !== undefined && message.category !== '') {
            obj.category = message.category;
        }
        return obj;
    },
    create(base) {
        return exports.Merchant.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMerchant();
        message.name = object.name ?? '';
        message.logoUrl = object.logoUrl ?? '';
        message.locationId = object.locationId ?? '';
        message.address = object.address ?? '';
        message.enrichedId = object.enrichedId ?? '';
        message.isBlockable = object.isBlockable ?? false;
        message.mcc = object.mcc ?? '';
        message.country = object.country ?? '';
        message.category = object.category ?? '';
        return message;
    },
};
function createBaseInstrument() {
    return { symbol: '', name: '', logoUrl: '' };
}
exports.Instrument = {
    fromJSON(object) {
        const message = {
            symbol: isSet(object.symbol) ? globalThis.String(object.symbol) : '',
            name: isSet(object.name) ? globalThis.String(object.name) : '',
        };
        if (isSet(object.logoUrl)) {
            message.logoUrl = globalThis.String(object.logoUrl);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.symbol !== '') {
            obj.symbol = message.symbol;
        }
        if (message.name !== '') {
            obj.name = message.name;
        }
        if (message.logoUrl !== undefined && message.logoUrl !== '') {
            obj.logoUrl = message.logoUrl;
        }
        return obj;
    },
    create(base) {
        return exports.Instrument.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseInstrument();
        message.symbol = object.symbol ?? '';
        message.name = object.name ?? '';
        message.logoUrl = object.logoUrl ?? '';
        return message;
    },
};
function createBaseSavingsInterest() {
    return {
        periodStartMs: '0',
        periodEndMs: '0',
        nominalRate: 0,
        apyRate: 0,
        averageDailyBalance: amount_1.Amount.fromPartial({}),
        earned: amount_1.Amount.fromPartial({}),
        timezone: '',
    };
}
exports.SavingsInterest = {
    fromJSON(object) {
        const message = {
            periodStartMs: isSet(object.periodStartMs) ? globalThis.String(object.periodStartMs) : '0',
            periodEndMs: isSet(object.periodEndMs) ? globalThis.String(object.periodEndMs) : '0',
            nominalRate: isSet(object.nominalRate) ? globalThis.Number(object.nominalRate) : 0,
            apyRate: isSet(object.apyRate) ? globalThis.Number(object.apyRate) : 0,
            averageDailyBalance: isSet(object.averageDailyBalance)
                ? amount_1.Amount.fromJSON(object.averageDailyBalance)
                : amount_1.Amount.fromPartial({}),
            earned: isSet(object.earned) ? amount_1.Amount.fromJSON(object.earned) : amount_1.Amount.fromPartial({}),
            timezone: isSet(object.timezone) ? globalThis.String(object.timezone) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.periodStartMs !== '0') {
            obj.periodStartMs = message.periodStartMs;
        }
        if (message.periodEndMs !== '0') {
            obj.periodEndMs = message.periodEndMs;
        }
        if (message.nominalRate !== 0) {
            obj.nominalRate = message.nominalRate;
        }
        if (message.apyRate !== 0) {
            obj.apyRate = message.apyRate;
        }
        if (message.averageDailyBalance !== undefined) {
            obj.averageDailyBalance = amount_1.Amount.toJSON(message.averageDailyBalance);
        }
        if (message.earned !== undefined) {
            obj.earned = amount_1.Amount.toJSON(message.earned);
        }
        if (message.timezone !== '') {
            obj.timezone = message.timezone;
        }
        return obj;
    },
    create(base) {
        return exports.SavingsInterest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSavingsInterest();
        message.periodStartMs = object.periodStartMs ?? '0';
        message.periodEndMs = object.periodEndMs ?? '0';
        message.nominalRate = object.nominalRate ?? 0;
        message.apyRate = object.apyRate ?? 0;
        message.averageDailyBalance =
            (object.averageDailyBalance !== undefined && object.averageDailyBalance !== null)
                ? amount_1.Amount.fromPartial(object.averageDailyBalance)
                : amount_1.Amount.fromPartial({});
        message.earned = (object.earned !== undefined && object.earned !== null)
            ? amount_1.Amount.fromPartial(object.earned)
            : amount_1.Amount.fromPartial({});
        message.timezone = object.timezone ?? '';
        return message;
    },
};
function createBaseCreditBillingFee() {
    return { dueDate: undefined, minimumPayment: undefined };
}
exports.CreditBillingFee = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.dueDate)) {
            message.dueDate = date_1.LocalDate.fromJSON(object.dueDate);
        }
        if (isSet(object.minimumPayment)) {
            message.minimumPayment = amount_1.Amount.fromJSON(object.minimumPayment);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.dueDate !== undefined) {
            obj.dueDate = date_1.LocalDate.toJSON(message.dueDate);
        }
        if (message.minimumPayment !== undefined) {
            obj.minimumPayment = amount_1.Amount.toJSON(message.minimumPayment);
        }
        return obj;
    },
    create(base) {
        return exports.CreditBillingFee.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCreditBillingFee();
        message.dueDate = (object.dueDate !== undefined && object.dueDate !== null)
            ? date_1.LocalDate.fromPartial(object.dueDate)
            : undefined;
        message.minimumPayment = (object.minimumPayment !== undefined && object.minimumPayment !== null)
            ? amount_1.Amount.fromPartial(object.minimumPayment)
            : undefined;
        return message;
    },
};
function createBaseCreditBillingInterest() {
    return {};
}
exports.CreditBillingInterest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.CreditBillingInterest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseCreditBillingInterest();
        return message;
    },
};
function createBaseCreditBalancePayment() {
    return { isManualPayment: false };
}
exports.CreditBalancePayment = {
    fromJSON(object) {
        const message = {
            isManualPayment: isSet(object.isManualPayment)
                ? globalThis.Boolean(object.isManualPayment)
                : false,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.isManualPayment !== false) {
            obj.isManualPayment = message.isManualPayment;
        }
        return obj;
    },
    create(base) {
        return exports.CreditBalancePayment.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCreditBalancePayment();
        message.isManualPayment = object.isManualPayment ?? false;
        return message;
    },
};
function createBasePointsReward() {
    return { offerName: '', offer: undefined, merchant: undefined };
}
exports.PointsReward = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.offerName)) {
            message.offerName = globalThis.String(object.offerName);
        }
        if (isSet(object.offer)) {
            message.offer = offer_1.Offer.fromJSON(object.offer);
        }
        if (isSet(object.merchant)) {
            message.merchant = exports.Merchant.fromJSON(object.merchant);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.offerName !== undefined && message.offerName !== '') {
            obj.offerName = message.offerName;
        }
        if (message.offer !== undefined) {
            obj.offer = offer_1.Offer.toJSON(message.offer);
        }
        if (message.merchant !== undefined) {
            obj.merchant = exports.Merchant.toJSON(message.merchant);
        }
        return obj;
    },
    create(base) {
        return exports.PointsReward.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePointsReward();
        message.offerName = object.offerName ?? '';
        message.offer = (object.offer !== undefined && object.offer !== null)
            ? offer_1.Offer.fromPartial(object.offer)
            : undefined;
        message.merchant = (object.merchant !== undefined && object.merchant !== null)
            ? exports.Merchant.fromPartial(object.merchant)
            : undefined;
        return message;
    },
};
function createBasePointsRedeem() {
    return { redeemedAmount: undefined, pointsCost: undefined, merchantName: '' };
}
exports.PointsRedeem = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.redeemedAmount)) {
            message.redeemedAmount = amount_1.Amount.fromJSON(object.redeemedAmount);
        }
        if (isSet(object.pointsCost)) {
            message.pointsCost = amount_1.Amount.fromJSON(object.pointsCost);
        }
        if (isSet(object.merchantName)) {
            message.merchantName = globalThis.String(object.merchantName);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.redeemedAmount !== undefined) {
            obj.redeemedAmount = amount_1.Amount.toJSON(message.redeemedAmount);
        }
        if (message.pointsCost !== undefined) {
            obj.pointsCost = amount_1.Amount.toJSON(message.pointsCost);
        }
        if (message.merchantName !== undefined && message.merchantName !== '') {
            obj.merchantName = message.merchantName;
        }
        return obj;
    },
    create(base) {
        return exports.PointsRedeem.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePointsRedeem();
        message.redeemedAmount = (object.redeemedAmount !== undefined && object.redeemedAmount !== null)
            ? amount_1.Amount.fromPartial(object.redeemedAmount)
            : undefined;
        message.pointsCost = (object.pointsCost !== undefined && object.pointsCost !== null)
            ? amount_1.Amount.fromPartial(object.pointsCost)
            : undefined;
        message.merchantName = object.merchantName ?? '';
        return message;
    },
};
function createBaseSubscription() {
    return { type: payment_subscription_1.SubscriptionPaymentContextSubscriptionType.SUBSCRIPTION_TYPE_UNKNOWN };
}
exports.Subscription = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.type)) {
            message.type = (0, payment_subscription_1.subscriptionPaymentContextSubscriptionTypeFromJSON)(object.type);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.type !== undefined &&
            message.type !== payment_subscription_1.SubscriptionPaymentContextSubscriptionType.SUBSCRIPTION_TYPE_UNKNOWN) {
            obj.type = (0, payment_subscription_1.subscriptionPaymentContextSubscriptionTypeToJSON)(message.type);
        }
        return obj;
    },
    create(base) {
        return exports.Subscription.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubscription();
        message.type = object.type ??
            payment_subscription_1.SubscriptionPaymentContextSubscriptionType.SUBSCRIPTION_TYPE_UNKNOWN;
        return message;
    },
};
function createBaseSubscriptionRefund() {
    return {
        type: payment_subscription_1.SubscriptionPaymentContextSubscriptionType.SUBSCRIPTION_TYPE_UNKNOWN,
        directDeposit: undefined,
        trial: undefined,
        reason: qualifying_event_1.QualifyingEvent.INVALID_QUALIFYING_EVENT,
    };
}
exports.SubscriptionRefund = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.type)) {
            message.type = (0, payment_subscription_1.subscriptionPaymentContextSubscriptionTypeFromJSON)(object.type);
        }
        if (isSet(object.directDeposit)) {
            message.directDeposit = payment_subscription_1.SubscriptionPaymentContextDirectDeposit.fromJSON(object.directDeposit);
        }
        if (isSet(object.trial)) {
            message.trial = payment_subscription_1.SubscriptionPaymentContextTrial.fromJSON(object.trial);
        }
        if (isSet(object.reason)) {
            message.reason = (0, qualifying_event_1.qualifyingEventFromJSON)(object.reason);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.type !== undefined &&
            message.type !== payment_subscription_1.SubscriptionPaymentContextSubscriptionType.SUBSCRIPTION_TYPE_UNKNOWN) {
            obj.type = (0, payment_subscription_1.subscriptionPaymentContextSubscriptionTypeToJSON)(message.type);
        }
        if (message.directDeposit !== undefined) {
            obj.directDeposit = payment_subscription_1.SubscriptionPaymentContextDirectDeposit.toJSON(message.directDeposit);
        }
        if (message.trial !== undefined) {
            obj.trial = payment_subscription_1.SubscriptionPaymentContextTrial.toJSON(message.trial);
        }
        if (message.reason !== undefined && message.reason !== qualifying_event_1.QualifyingEvent.INVALID_QUALIFYING_EVENT) {
            obj.reason = (0, qualifying_event_1.qualifyingEventToJSON)(message.reason);
        }
        return obj;
    },
    create(base) {
        return exports.SubscriptionRefund.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSubscriptionRefund();
        message.type = object.type ??
            payment_subscription_1.SubscriptionPaymentContextSubscriptionType.SUBSCRIPTION_TYPE_UNKNOWN;
        message.directDeposit = (object.directDeposit !== undefined && object.directDeposit !== null)
            ? payment_subscription_1.SubscriptionPaymentContextDirectDeposit.fromPartial(object.directDeposit)
            : undefined;
        message.trial = (object.trial !== undefined && object.trial !== null)
            ? payment_subscription_1.SubscriptionPaymentContextTrial.fromPartial(object.trial)
            : undefined;
        message.reason = object.reason ?? qualifying_event_1.QualifyingEvent.INVALID_QUALIFYING_EVENT;
        return message;
    },
};
function createBaseCashAdvance() {
    return { loans: [] };
}
exports.CashAdvance = {
    fromJSON(object) {
        const message = {};
        if (globalThis.Array.isArray(object?.loans)) {
            message.loans = object.loans.map((e) => activity_common_1.CompletedLoan.fromJSON(e));
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.loans?.length) {
            obj.loans = message.loans.map((e) => activity_common_1.CompletedLoan.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.CashAdvance.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCashAdvance();
        message.loans = object.loans?.map((e) => activity_common_1.CompletedLoan.fromPartial(e)) || [];
        return message;
    },
};
function createBaseSavingsMatch() {
    return {
        sourceUserId: '',
        destinationUserId: '',
        savingsGoalTitle: '',
        sourceUserFirstName: '',
        destinationUserFirstName: '',
    };
}
exports.SavingsMatch = {
    fromJSON(object) {
        const message = {
            sourceUserId: isSet(object.sourceUserId) ? globalThis.String(object.sourceUserId) : '',
            destinationUserId: isSet(object.destinationUserId)
                ? globalThis.String(object.destinationUserId)
                : '',
            savingsGoalTitle: isSet(object.savingsGoalTitle)
                ? globalThis.String(object.savingsGoalTitle)
                : '',
        };
        if (isSet(object.sourceUserFirstName)) {
            message.sourceUserFirstName = globalThis.String(object.sourceUserFirstName);
        }
        if (isSet(object.destinationUserFirstName)) {
            message.destinationUserFirstName = globalThis.String(object.destinationUserFirstName);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.sourceUserId !== '') {
            obj.sourceUserId = message.sourceUserId;
        }
        if (message.destinationUserId !== '') {
            obj.destinationUserId = message.destinationUserId;
        }
        if (message.savingsGoalTitle !== '') {
            obj.savingsGoalTitle = message.savingsGoalTitle;
        }
        if (message.sourceUserFirstName !== undefined && message.sourceUserFirstName !== '') {
            obj.sourceUserFirstName = message.sourceUserFirstName;
        }
        if (message.destinationUserFirstName !== undefined && message.destinationUserFirstName !== '') {
            obj.destinationUserFirstName = message.destinationUserFirstName;
        }
        return obj;
    },
    create(base) {
        return exports.SavingsMatch.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSavingsMatch();
        message.sourceUserId = object.sourceUserId ?? '';
        message.destinationUserId = object.destinationUserId ?? '';
        message.savingsGoalTitle = object.savingsGoalTitle ?? '';
        message.sourceUserFirstName = object.sourceUserFirstName ?? '';
        message.destinationUserFirstName = object.destinationUserFirstName ?? '';
        return message;
    },
};
function createBaseGiftCardPointsRedeem() {
    return { orderId: '', orderDetails: undefined };
}
exports.GiftCardPointsRedeem = {
    fromJSON(object) {
        const message = {
            orderId: isSet(object.orderId) ? globalThis.String(object.orderId) : '',
        };
        if (isSet(object.orderDetails)) {
            message.orderDetails = payment_gift_card_order_1.GiftCardOrderDetails.fromJSON(object.orderDetails);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.orderId !== '') {
            obj.orderId = message.orderId;
        }
        if (message.orderDetails !== undefined) {
            obj.orderDetails = payment_gift_card_order_1.GiftCardOrderDetails.toJSON(message.orderDetails);
        }
        return obj;
    },
    create(base) {
        return exports.GiftCardPointsRedeem.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGiftCardPointsRedeem();
        message.orderId = object.orderId ?? '';
        message.orderDetails = (object.orderDetails !== undefined && object.orderDetails !== null)
            ? payment_gift_card_order_1.GiftCardOrderDetails.fromPartial(object.orderDetails)
            : undefined;
        return message;
    },
};
function createBaseGiftCardPointsRedeemReversal() {
    return { orderId: '', orderDetails: undefined };
}
exports.GiftCardPointsRedeemReversal = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.orderId)) {
            message.orderId = globalThis.String(object.orderId);
        }
        if (isSet(object.orderDetails)) {
            message.orderDetails = payment_gift_card_order_1.GiftCardOrderDetails.fromJSON(object.orderDetails);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.orderId !== undefined && message.orderId !== '') {
            obj.orderId = message.orderId;
        }
        if (message.orderDetails !== undefined) {
            obj.orderDetails = payment_gift_card_order_1.GiftCardOrderDetails.toJSON(message.orderDetails);
        }
        return obj;
    },
    create(base) {
        return exports.GiftCardPointsRedeemReversal.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGiftCardPointsRedeemReversal();
        message.orderId = object.orderId ?? '';
        message.orderDetails = (object.orderDetails !== undefined && object.orderDetails !== null)
            ? payment_gift_card_order_1.GiftCardOrderDetails.fromPartial(object.orderDetails)
            : undefined;
        return message;
    },
};
function activityContextTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_ACTIVITY_CONTEXT':
            return ActivityContextType.INVALID_ACTIVITY_CONTEXT;
        case 1:
        case 'CREDIT_BALANCE_PAYMENT':
            return ActivityContextType.CREDIT_BALANCE_PAYMENT;
        case 2:
        case 'INSTALLMENT_LOAN_PAYMENT':
            return ActivityContextType.INSTALLMENT_LOAN_PAYMENT;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return ActivityContextType.UNRECOGNIZED;
    }
}
exports.activityContextTypeFromJSON = activityContextTypeFromJSON;
function activityContextTypeToJSON(object) {
    switch (object) {
        case ActivityContextType.INVALID_ACTIVITY_CONTEXT:
            return 'INVALID_ACTIVITY_CONTEXT';
        case ActivityContextType.CREDIT_BALANCE_PAYMENT:
            return 'CREDIT_BALANCE_PAYMENT';
        case ActivityContextType.INSTALLMENT_LOAN_PAYMENT:
            return 'INSTALLMENT_LOAN_PAYMENT';
        case ActivityContextType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.activityContextTypeToJSON = activityContextTypeToJSON;
function purchaseAccountTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_PURCHASE_ACCOUNT_TYPE':
            return PurchaseAccountType.INVALID_PURCHASE_ACCOUNT_TYPE;
        case 1:
        case 'SECURED_PURCHASE_ACCOUNT':
            return PurchaseAccountType.SECURED_PURCHASE_ACCOUNT;
        case 2:
        case 'UNSECURED_PURCHASE_ACCOUNT':
            return PurchaseAccountType.UNSECURED_PURCHASE_ACCOUNT;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return PurchaseAccountType.UNRECOGNIZED;
    }
}
exports.purchaseAccountTypeFromJSON = purchaseAccountTypeFromJSON;
function purchaseAccountTypeToJSON(object) {
    switch (object) {
        case PurchaseAccountType.INVALID_PURCHASE_ACCOUNT_TYPE:
            return 'INVALID_PURCHASE_ACCOUNT_TYPE';
        case PurchaseAccountType.SECURED_PURCHASE_ACCOUNT:
            return 'SECURED_PURCHASE_ACCOUNT';
        case PurchaseAccountType.UNSECURED_PURCHASE_ACCOUNT:
            return 'UNSECURED_PURCHASE_ACCOUNT';
        case PurchaseAccountType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.purchaseAccountTypeToJSON = purchaseAccountTypeToJSON;
function purchaseEventTypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_PURCHASE_EVENT_TYPE':
            return PurchaseEventType.INVALID_PURCHASE_EVENT_TYPE;
        case 1:
        case 'PENDING_AUTHORIZATION_EVENT':
            return PurchaseEventType.PENDING_AUTHORIZATION_EVENT;
        case 2:
        case 'DECLINED_AUTHORIZATION_EVENT':
            return PurchaseEventType.DECLINED_AUTHORIZATION_EVENT;
        case 3:
        case 'REVERSED_AUTHORIZATION_EVENT':
            return PurchaseEventType.REVERSED_AUTHORIZATION_EVENT;
        case 4:
        case 'CAPTURE_EVENT':
            return PurchaseEventType.CAPTURE_EVENT;
        case 5:
        case 'REFUND_EVENT':
            return PurchaseEventType.REFUND_EVENT;
        case 6:
        case 'DISPUTE_CREDIT_EVENT':
            return PurchaseEventType.DISPUTE_CREDIT_EVENT;
        case 7:
        case 'DISPUTE_CREDIT_REVERSAL_EVENT':
            return PurchaseEventType.DISPUTE_CREDIT_REVERSAL_EVENT;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return PurchaseEventType.UNRECOGNIZED;
    }
}
exports.purchaseEventTypeFromJSON = purchaseEventTypeFromJSON;
function purchaseEventTypeToJSON(object) {
    switch (object) {
        case PurchaseEventType.INVALID_PURCHASE_EVENT_TYPE:
            return 'INVALID_PURCHASE_EVENT_TYPE';
        case PurchaseEventType.PENDING_AUTHORIZATION_EVENT:
            return 'PENDING_AUTHORIZATION_EVENT';
        case PurchaseEventType.DECLINED_AUTHORIZATION_EVENT:
            return 'DECLINED_AUTHORIZATION_EVENT';
        case PurchaseEventType.REVERSED_AUTHORIZATION_EVENT:
            return 'REVERSED_AUTHORIZATION_EVENT';
        case PurchaseEventType.CAPTURE_EVENT:
            return 'CAPTURE_EVENT';
        case PurchaseEventType.REFUND_EVENT:
            return 'REFUND_EVENT';
        case PurchaseEventType.DISPUTE_CREDIT_EVENT:
            return 'DISPUTE_CREDIT_EVENT';
        case PurchaseEventType.DISPUTE_CREDIT_REVERSAL_EVENT:
            return 'DISPUTE_CREDIT_REVERSAL_EVENT';
        case PurchaseEventType.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.purchaseEventTypeToJSON = purchaseEventTypeToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=activity-context.js.map